/* eslint-disable no-unused-vars */
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import {
  Alert,
  Box, Button,
  CircularProgress,
  Dialog, DialogActions,
  DialogContent, DialogContentText, DialogTitle,
  FormControl, Grid,
  IconButton,
  InputLabel,
  List, ListItem,
  MenuItem, Paper, Select,
  Snackbar,
  Tab, Tabs, TextField,
  Tooltip,
  Typography,
  LinearProgress,
  Checkbox,
  FormControlLabel,
  Collapse,
  Stack,
  Menu,
  Autocomplete,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Divider,
  Chip,
  Modal,
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import DocumentPreviewer from '../sections/matter/DocumentPicker'; // Import DocumentPreviewer
import { getUploadsRelativePath } from '../utils/resolveDocumentUrl';
import { DEFAULT_FOLDERS } from '../utils/documentFolders';
import * as XLSX from 'xlsx'; // Importing SheetJS for Excel files
import AccountsTab from '../sections/matter/AccountsTab';
import NPAAccountsTab from '../sections/matter/NPAAccountsTab';
import AppointmentsTab from '../sections/matter/appointmentsTab';
import CuratorReportTab from '../sections/matter/CuratorReportTab';
import CashbookTransactionsTab from '../sections/matter/CashbookTransactionsTab';
import AssetsTab from '../sections/matter/AssetsTab';
import { useTheme } from '@mui/material/styles';
import axios from 'axios';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SettingsIcon from '@mui/icons-material/Settings';
import EditIcon from '@mui/icons-material/Edit';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
// 🎯 Add this import at the top (adjust the path if necessary)
import MatterForm from '../sections/matter/MatterForm';
import PrintIcon from '@mui/icons-material/Print';
import ClaimsTab from '../sections/matter/ClaimsTab';
import DebtorsTab from '../sections/matter/DebtorsTab';
import AssetInsuranceTab from '../sections/matter/AssetInsuranceTab';
import EnquiryTab from '../sections/matter/EnquiryTab';
import TasksTab from '../sections/matter/TasksTab';



// Function to render different types of document previews
const renderDocumentPreview = (file) => {
  const fileExtension = file.filename.split('.').pop().toLowerCase();
  console.log('File:', file.filename, 'Extension:', fileExtension); // Debugging line

  // Check for file extension and render appropriate preview
  if (fileExtension === 'pdf') {
    return (
      <Box sx={{ width: '100%', height: '60vh' }}>
        <embed
          src={`https://demo.insollex.com/api/uploads/${file.filename}`}
          width="100%"
          height="100%"
          type="application/pdf"
        />
      </Box>
    );
  } else if (['jpg', 'jpeg', 'png'].includes(fileExtension)) {
    return (
      <Box
        sx={{
          width: '100%',
          height: '40vh', // fixed height instead of maxHeight
          overflow: 'auto',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center', // center vertically too
        }}
      >
        <img
          src={`https://demo.insollex.com/api/uploads/${file.filename}`}
          alt="Document preview"
          style={{
            maxHeight: '100%',
            maxWidth: '100%',
            objectFit: 'contain',
            borderRadius: 8,
          }}
        />
      </Box>
    );
  } else if (fileExtension === 'txt') {
    return <TextFileViewer file={file} />;
  } else if (fileExtension === 'docx') {
    const docs = [
      {
        uri: `https://demo.insollex.com/api/uploads/${file.filename}`,
        fileType: 'docx', // Specify the file type
      },
    ];
    console.log("Stepping");

    return (
      <Box sx={{ width: '100%', height: '60vh' }}>
        <DocViewer
          documents={docs}
          pluginRenderers={DocViewerRenderers}
          style={{ height: '100%', width: '100%' }} // Add this!
          config={{
            header: {
              disableHeader: true, // Optional: hide top bar if needed
            },
          }}
        />
      </Box>
    );
  } else if (fileExtension === 'xlsx') {
    return (
      <Box sx={{ width: '100%' }}>
        <Typography variant="h6">Excel File Preview (converted)</Typography>
        <ExcelFileViewer file={file} />
      </Box>
    );
  }

  return <Typography>No preview available for this file type</Typography>;
};
// Separate component to handle rendering of text files
const TextFileViewer = ({ file }) => {
  const [fileContent, setFileContent] = useState('');

  useEffect(() => {
    const fetchTextFile = async () => {
      try {
        const response = await fetch(`https://demo.insollex.com/api/uploads/${file.filename}`);
        if (response.ok) {
          const text = await response.text();
          setFileContent(text);
        } else {
          console.error('Failed to fetch text file content');
        }
      } catch (error) {
        console.error('Error fetching text file:', error);
      }
    };

    fetchTextFile();
  }, [file.filename]);

  return <pre>{fileContent}</pre>;
};

// Excel File Viewer using SheetJS
const ExcelFileViewer = ({ file }) => {
  const [excelData, setExcelData] = useState(null);
  const [sheetNames, setSheetNames] = useState([]);
  const [selectedSheet, setSelectedSheet] = useState(0);

  useEffect(() => {
    const fetchExcelFile = async () => {
      try {
        const response = await fetch(`https://demo.insollex.com/api/uploads/${file.filename}`);
        if (response.ok) {
          const arrayBuffer = await response.arrayBuffer();
          const data = new Uint8Array(arrayBuffer);
          const workbook = XLSX.read(data, { type: 'array' });
          setSheetNames(workbook.SheetNames); // Save all sheet names
          const sheet = workbook.Sheets[workbook.SheetNames[selectedSheet]];
          const html = XLSX.utils.sheet_to_html(sheet);
          setExcelData(html);
        } else {
          console.error('Failed to fetch Excel file');
        }
      } catch (error) {
        console.error('Error fetching Excel file:', error);
      }
    };

    fetchExcelFile();
  }, [file.filename, selectedSheet]);

  return (
    <div>
      <select onChange={(e) => setSelectedSheet(Number(e.target.value))} value={selectedSheet}>
        {sheetNames.map((name, index) => (
          <option key={index} value={index}>{name}</option>
        ))}
      </select>

      <div
        dangerouslySetInnerHTML={{
          __html: excelData,
        }}
      />
    </div>
  );
};

// --- FOLDER STRUCTURE & RENDERING ---

const MatterDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [matter, setMatter] = useState(null);
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState(0);  // For tab control
  const [isSaveAttempted, setIsSaveAttempted] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [isEditingMode, setIsEditingMode] = useState(true); // Default to true (Editable)
  const hiddenFileInput = useRef(null);
  // Auto-save: skips the very first formData change after each fetch (the fetch itself
  // populating state shouldn't count as an edit), then debounces real edits before saving.
  const skipNextAutoSaveRef = useRef(true);
  const autoSaveTimerRef = useRef(null);
  const [autoSaveStatus, setAutoSaveStatus] = useState(''); // '', 'saving', 'saved'
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [openPreview, setOpenPreview] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [estateNo] = useState('');
  const { legalMatterId } = useParams();  // if you're using React Router's useParams
  const [documents, setDocuments] = useState([]);
  const [error, setError] = useState(null);
  const { search } = useLocation();
  const token = new URLSearchParams(search).get('token');
  const [isInvitedUser, setIsInvitedUser] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const theme = useTheme();
  const [user, setUser] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [showTrash, setShowTrash] = useState(false);

  const [assetType, setAssetType] = useState('');
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = React.useRef(null);
  const [assetsMenuAnchor, setAssetsMenuAnchor] = useState(null);
  // 🎯 Add this state declaration
const [openForm, setOpenForm] = useState(false);
const [newCommentText, setNewCommentText] = useState(''); // 🎯 NEW: Added for comments
const [commentIsTask, setCommentIsTask] = useState(false);

// --- State for inline comment editing ---
const [editingCommentId, setEditingCommentId] = useState(null);
const [editingCommentText, setEditingCommentText] = useState('');

// --- State for inline bond editing ---
const [bondForm, setBondForm] = useState(null);
const [editingBondId, setEditingBondId] = useState(null);

// --- State for inline insolvent editing ---
const [insolventFormOpen, setInsolventFormOpen] = useState(false);
const [editingInsolventIndex, setEditingInsolventIndex] = useState(null);
const [insolventForm, setInsolventForm] = useState({
    id: '', fullName: '', idNumber: '', status: 'Alive', maritalStatus: 'Single', phone: '', email: '', address: '', taxNo: '', vatNo: ''
});

// --- State for inline trustee editing ---
const [trusteeFormOpen, setTrusteeFormOpen] = useState(false);
const [editingTrusteeIndex, setEditingTrusteeIndex] = useState(null);
const [trusteeForm, setTrusteeForm] = useState({
    firmName: '', fullName: '', phone: '', email: '', vatRegistered: false, vatNumber: '', saveToDirectory: false
});

// --- State for inline director/member editing ---
const [dirMemFormOpen, setDirMemFormOpen] = useState(false);
const [editingDirMemIndex, setEditingDirMemIndex] = useState(null);
const [dirMemForm, setDirMemForm] = useState({
    id: '', fullName: '', idNumber: '', status: 'Alive', phone: '', email: '', address: ''
});

// --- State for inline respondent editing ---
const [respondentFormOpen, setRespondentFormOpen] = useState(false);
const [editingRespondentId, setEditingRespondentId] = useState(null);
const [respondentForm, setRespondentForm] = useState({
    id: '', name: '', idNo: '', contactDetails: '', emailAddress: '', maritalStatus: 'Single'
});

// --- State for linking a document to an NPA order (shared picker, targets whichever order was clicked) ---
const [orderDocPickerOpen, setOrderDocPickerOpen] = useState(false);
const [activeOrderDocField, setActiveOrderDocField] = useState(null);

const ORDER_DOCUMENT_FIELDS = [
    { label: 'Application', field: 'applicationDocUrl' },
    { label: 'Letter of Curatorship', field: 'letterOfCuratorshipDocUrl' },
    { label: 'Prov Preservation Order', field: 'provPreservationOrderDocUrl' },
    { label: 'Final Preservation Order', field: 'finalPreservationOrderDocUrl' },
    { label: 'Prov Restraint Order', field: 'provRestraintOrderDocUrl' },
    { label: 'Final Restraint Order', field: 'finalRestraintOrderDocUrl' },
    { label: 'Confiscation Order', field: 'confiscationOrderDocUrl' },
    { label: 'Anticipation Order', field: 'anticipationOrderDocUrl' },
    { label: 'Forfeiture Order', field: 'forfeitureOrderDocUrl' },
    { label: 'Realisation Order', field: 'realisationOrderDocUrl' },
];

const handleOpenOrderDocPicker = (field) => {
    setActiveOrderDocField(field);
    setOrderDocPickerOpen(true);
};

// Attaching/removing an order document is a discrete, complete action from the user's
// point of view, so save it immediately rather than relying on the page's separate
// "Save"/"Update Matter" step - otherwise the link silently reverts on reload if that
// step is skipped.
const saveOrderDocField = async (field, value) => {
    handleFieldChange({ target: { name: field, value } });
    if (!id) return;
    try {
        await axios.put(`https://demo.insollex.com/api/legal-matter/${id}`, { [field]: value });
    } catch (e) {
        console.error("Failed to save order document link", e);
        window.alert("Failed to save this document link to the server. It will not persist after a reload - please try again or contact support.");
    }
};


// --- State for Telephone Book Directory ---
const [manageDirectoryOpen, setManageDirectoryOpen] = useState(false);
const [trusteeDirectory, setTrusteeDirectory] = useState([]);

useEffect(() => {
    const stored = localStorage.getItem('insollex_trustee_directory');
    if (stored) {
        try { setTrusteeDirectory(JSON.parse(stored)); } catch (e) {}
    }
}, []);

const handleDeleteFromDirectory = (contactName) => {
    if(window.confirm(`Delete ${contactName} from directory?`)) {
        const newDir = trusteeDirectory.filter(t => t.fullName !== contactName);
        setTrusteeDirectory(newDir);
        localStorage.setItem('insollex_trustee_directory', JSON.stringify(newDir));
    }
};

    // --- State for Attorney Directory ---
    const [manageAttorneyDirectoryOpen, setManageAttorneyDirectoryOpen] = useState(false);
    const [attorneyDirectory, setAttorneyDirectory] = useState([]);
    
    // --- State for Adding/Editing Attorney directly in Directory ---
    const [addAttorneyFormOpen, setAddAttorneyFormOpen] = useState(false);
    const [attorneyForm, setAttorneyForm] = useState({ originalName: '', firmName: '', fullName: '', phone: '', email: '' });

    useEffect(() => {
        const fetchAttorneys = async () => {
            try {
                const res = await axios.get('https://demo.insollex.com/api/attorneys');
                setAttorneyDirectory(res.data);
            } catch (e) {
                console.error("Error fetching attorney directory", e);
            }
        };
        fetchAttorneys();
    }, []);

    const handleDeleteFromAttorneyDirectory = async (contactName) => {
        if(window.confirm(`Delete ${contactName} from directory?`)) {
            try {
                await axios.delete(`https://demo.insollex.com/api/attorneys/${encodeURIComponent(contactName)}`);
                setAttorneyDirectory(prev => prev.filter(a => a.fullName !== contactName));
                setSnackbarMessage("Attorney deleted from directory.");
                setSnackbarSeverity('success');
                setSnackbarOpen(true);
            } catch (error) {
                console.error("Error deleting attorney", error);
            }
        }
    };

    const handleSaveNewAttorneyToDirectory = async () => {
        if (!attorneyForm.fullName) return;
        try {
            await axios.post('https://demo.insollex.com/api/attorneys', attorneyForm);
            const res = await axios.get('https://demo.insollex.com/api/attorneys');
            setAttorneyDirectory(res.data);
            setSnackbarMessage("Attorney saved to directory!");
            setSnackbarSeverity('success');
            setSnackbarOpen(true);
            setAddAttorneyFormOpen(false);
        } catch (error) {
            console.error("Error saving attorney", error);
        }
    };

    const handleEditAttorneyInDirectory = (attorney) => {
        setAttorneyForm({
            originalName: attorney.fullName,
            firmName: attorney.firmName,
            fullName: attorney.fullName,
            phone: attorney.phone,
            email: attorney.email
        });
        setAddAttorneyFormOpen(true);
    };

    const handleSaveAttorneyToDirectory = async () => {
        if (!formData.attorneyName) return;
        try {
            await axios.post('https://demo.insollex.com/api/attorneys', {
                firmName: formData.attorneyFirm || '',
                fullName: formData.attorneyName || '',
                phone: formData.attorneyPhone || '',
                email: formData.attorneyEmail || ''
            });
            const res = await axios.get('https://demo.insollex.com/api/attorneys');
            setAttorneyDirectory(res.data);
            setSnackbarMessage("Attorney saved to directory!");
            setSnackbarSeverity('success');
            setSnackbarOpen(true);
        } catch (error) {
            console.error("Error saving attorney", error);
        }
    };

  // 🛠️ MOVED HELPER: Function to ensure bond data is in the array format expected by the dynamic form
  const ensureBondEntriesFormat = (fetchedData) => {
      // 1. If bondEntries already exists and is an array, return it directly.
      if (fetchedData.bondEntries && Array.isArray(fetchedData.bondEntries) && fetchedData.bondEntries.length > 0) {
          return fetchedData.bondEntries;
      }
      
      if (fetchedData.bondEntries && typeof fetchedData.bondEntries === 'string') {
          try {
              const parsed = JSON.parse(fetchedData.bondEntries);
              if (Array.isArray(parsed) && parsed.length > 0) return parsed;
          } catch(e) {}
      }

      // 2. If flat fields exist (from old data/initial setup), create a single array entry.
      if (fetchedData.insurerName || fetchedData.insuredAmount || fetchedData.policyNumber || fetchedData.finalInsuredAmount) {
          return [{
              id: Date.now(), // Unique ID for mapping keys
              insurerName: fetchedData.insurerName || '',
              insuredAmount: fetchedData.insuredAmount || '',
              policyNumber: fetchedData.policyNumber || '',
              inceptionDate: fetchedData.inceptionDate || '',
              policyRenewalDate: fetchedData.policyRenewalDate || '',
              reductionIncreaseDate: fetchedData.reductionIncreaseDate || '',
              finalInsuredAmount: fetchedData.finalInsuredAmount || '',
              isPaid: fetchedData.isPaid || false,
          }];
      }
      
      // 3. Otherwise, return an empty array.
      return [];
  };


  const isDarkMode = theme.palette.mode === 'dark';
  const [updatedMatter, setUpdatedMatter] = useState({
    // --- Core Identity ---
    matterName: '',
    matterType: '',
    isFriendly: false,
    description: '',
    status: '',
    client: '',
    caseNumber: '', 
    estateNo: '',
    magistrateOffice: '',
    meetingPlaceExtraInfo: '',
    mastersOffice: '',
    estateCapturedBy: '',
    estateClassification: '',

    // --- Classification Details (Person/Company/CC) ---
    initials: '',
    firstName: '', 
    lastName: '',
    idNumber: '',
    registrationNo: '',
    vatNo: '',
    taxNo: '',
    finalCertificate: '', 
    provisionalCertificateApplication: '',

    // --- Date Fields ---
    provisionalLiquidationDate: '',
    finalLiquidationDate: '',
    provisionalAppointmentDate: '',
    finalAppointmentDate: '',
    reductionRequestDate: '',
    reductionAllowedDate: '',
    dischargeDate: '',
    acceptanceLetterDate: '', 
    preOrderProvDate: '', 
    preOrderFinalDate: '',
    forfeitureOrderDate: '',
    resOrderProvDate: '',
    resOrderFinalDate: '',
    confiscationOrderDate: '',
    realisationOrderDate: '',
    policyRenewalDate: '',
    reductionIncreaseDate: '',
    bankAccountOpenedDate: '', // 🆕 New
    bankAccountClosedDate: '', // 🆕 New
    cm26liqDate: '',
    hasIncomeTax: false,
    hasVat: false,

    // --- Matter Status: Set Aside / Not Proceeding ---
    isSetAside: false,
    setAsideDate: '',
    setAsideReason: '',
    isNotProceeding: false,
    notProceedingDate: '',
    notProceedingReason: '',

    // --- Trustee Info (8 Trustees) ---
    trustee1FirmName: '', trustee1FullName: '', trustee1Telephone: '', trustee1Email: '', trustee1VatRegistered: false, trustee1VatNumber: '',
    trustee2FirmName: '', trustee2FullName: '', trustee2Telephone: '', trustee2Email: '', trustee2VatRegistered: false, trustee2VatNumber: '',
    trustee3FirmName: '', trustee3FullName: '', trustee3Telephone: '', trustee3Email: '', trustee3VatRegistered: false, trustee3VatNumber: '',
    trustee4FirmName: '', trustee4FullName: '', trustee4Telephone: '', trustee4Email: '', trustee4VatRegistered: false, trustee4VatNumber: '',
    trustee5FirmName: '', trustee5FullName: '', trustee5Telephone: '', trustee5Email: '', trustee5VatRegistered: false, trustee5VatNumber: '',
    trustee6FirmName: '', trustee6FullName: '', trustee6Telephone: '', trustee6Email: '', trustee6VatRegistered: false, trustee6VatNumber: '',
    trustee7FirmName: '', trustee7FullName: '', trustee7Telephone: '', trustee7Email: '', trustee7VatRegistered: false, trustee7VatNumber: '',
    trustee8FirmName: '', trustee8FullName: '', trustee8Telephone: '', trustee8Email: '', trustee8VatRegistered: false, trustee8VatNumber: '',

    // --- 🆕 Applicant Information (Section 1.1.1) ---
    applicantName: '',
    applicantPhone: '',
    applicantEmail: '',
    applicantAddress: '',

    // --- 🆕 Attorney Applicant Information (Section 1.1.1) ---
    attorneyFirm: '',
    attorneyName: '',
    attorneyPhone: '',
    attorneyEmail: '',
    attorneyRef: '',
    taxedBillAmount: '',
    willSubmitTaxedBill: false,
    taxedBillObtained: false,

    // --- 🆕 Master Information (Section 1.1.2) ---
    masterContactPerson: '',
    masterContactEmail: '',

    // --- Bank & Financial ---
    bankName: '',
    bankAccountNo: '',
    branchName: '',
    branchCode: '',

    // --- Cashbook Totals ---
    cashbookBalance: '',
    cashbookTotalDEP: '', cashbookTotalEXP: '', cashbookTotalDVO: '',
    cashbookTotalEVO: '', cashbookTotalDBA: '', cashbookTotalEBA: '',
    cashbookTotalDEC: '', cashbookTotalSDY: '', cashbookTotalDEB: '',
    cashbookTotalBAP: '', cashbookTotalVSK: '', cashbookTotalRPD: '',
    cashbookTotalDRS: '', cashbookTotalPMT: '', cashbookTotalBDP: '',
    cashbookTotalINV: '', cashbookTotalBLN: '', cashbookTotalREK: '',
    
    // Inhouse Totals
    inhouseTotalTRAV: '', inhouseTotalCOPY: '', inhouseTotalPOST: '',
    inhouseTotalLODG: '', inhouseTotalMISC: '',

    // --- Dynamic Arrays ---
    bondEntries: [],
    respondents: [],
    anticipationOrderRespondentIds: [], // 🆕 NPA: respondents/defendants an Anticipation Order applies to
    confiscationOrderRespondentIds: [], // 🆕 NPA: respondents/defendants a Confiscation Order was made against
    curatorReports: [], // 🆕 NPA: list of filed Curator's Reports
    // 🆕 NPA: linked document for each order (see ORDER_DOCUMENT_FIELDS)
    applicationDocUrl: '',
    letterOfCuratorshipDocUrl: '',
    letterOfCuratorshipNumber: '',
    letterOfCuratorshipDate: '',
    provPreservationOrderDocUrl: '',
    finalPreservationOrderDocUrl: '',
    provRestraintOrderDocUrl: '',
    finalRestraintOrderDocUrl: '',
    confiscationOrderDocUrl: '',
    anticipationOrderDocUrl: '',
    forfeitureOrderDocUrl: '',
    realisationOrderDocUrl: '',
    documents: [],
    stakeholders: [], // 🆕 Used for Directors/Members/Insolvents tables
    commentsList: [], // 🆕 Used for the new Dated Comments & Task Log
    requisitions: [],
    ldExtensions: [],
    claimsList: [],
    debtorsList: [],
    assetInsuranceList: [],
    enquiriesList: [],
    tasksList: [],
    bankAccounts: [],
    activeLedgers: [],

    // --- Checkbox Tracking ---
    courtAppObtained: false,
    provOrderObtained: false,
    applicantIsDebtor: false, // 🎯 NEW FIELD
    hasProvisionalOrders: true, // Default to true for backward compatibility
    finalOrderObtained: false,
    provAppObtained: false,
    finalAppObtained: false,
    cm26liqObtained: false,
    cm100Obtained: false,
    provisionalCertificate: false,

    // --- Misc ---
    reminder: '',
    comment: '', // Legacy single-string comment (can be removed if using commentsList)
});

  const formatDate = (date) => {
    if (!date) return '';
    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date.substring(0, 10))) return date.substring(0, 10);
    try {
        return new Date(date).toISOString().split('T')[0];
    } catch (e) { return ''; }
  };

  const displayDate = (date) => {
    if (!date) return '---';
    try {
        const d = new Date(date);
        return isNaN(d.getTime()) ? date : d.toLocaleDateString('en-ZA', { day: '2-digit', month: '2-digit', year: 'numeric' });
    } catch (e) { return date; }
  };

  // Locale-robust money parser. Handles values captured/imported in any of the common
  // SA formats: "1964495.30", "1 964 495,30", "1.964.495,30", "1,964,495.30",
  // "1,964,495,30" (all-comma) and plain numbers. Needed because a bare
  // parseFloat("1.964.495,30") returns 1.964, which is why bond amounts rendered "R 1,96".
  const parseMoney = (val) => {
    if (val === null || val === undefined || val === '') return 0;
    if (typeof val === 'number') return isNaN(val) ? 0 : val;
    let s = String(val).trim().replace(/[^0-9.,-]/g, '');
    if (!s) return 0;
    const lastComma = s.lastIndexOf(',');
    const lastDot = s.lastIndexOf('.');
    const decimalTail = (str, sep) => {
      // The last separator is the decimal point only when 1-2 digits follow it.
      const tail = str.slice(str.lastIndexOf(sep) + 1);
      return tail.length > 0 && tail.length <= 2;
    };
    if (lastComma > -1 && lastDot > -1) {
      s = lastComma > lastDot
        ? s.slice(0, lastComma).replace(/[.,]/g, '') + '.' + s.slice(lastComma + 1) // 1.964.495,30 -> 1964495.30
        : s.replace(/,/g, '');                                                      // 1,964,495.30 -> 1964495.30
    } else if (lastComma > -1) {
      s = decimalTail(s, ',')
        ? s.slice(0, lastComma).replace(/,/g, '') + '.' + s.slice(lastComma + 1) // 1,964,495,30 -> 1964495.30
        : s.replace(/,/g, '');                                                   // 1,964,495 -> 1964495
    } else if ((s.match(/\./g) || []).length > 1) {
      s = s.replace(/\./g, '');                    // 1.964.495 -> 1964495
    }
    const n = parseFloat(s);
    return isNaN(n) ? 0 : n;
  };

  const formatMoney = (val) => `R ${parseMoney(val).toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  const [formData, setFormData] = useState({});
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [estate, setEstate] = useState(null);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [openFolders, setOpenFolders] = useState({});
  const [folderDialogOpen, setFolderDialogOpen] = useState(false);
  const [folderForUpload, setFolderForUpload] = useState(null);
  const [isPublic, setIsPublic] = React.useState(false);
  const [selectedIsPublic, setSelectedIsPublic] = useState(false);
  const [masterModalOpen, setMasterModalOpen] = useState(false);

const handleOpenMasterModal = () => setMasterModalOpen(true);
const handleCloseMasterModal = () => setMasterModalOpen(false);

  // Folder management state
  const [newFolderDialogOpen, setNewFolderDialogOpen] = useState(false);
  const [newFolderName, setNewFolderName] = useState('');
  const [isSubfolderDialog, setIsSubfolderDialog] = useState(false);
  const [parentForNewFolder, setParentForNewFolder] = useState('');
  const [renameFolderDialogOpen, setRenameFolderDialogOpen] = useState(false);
  const [renameFolderName, setRenameFolderName] = useState('');
  const [folderToRename, setFolderToRename] = useState(null);

  // 🎯 10.1: Rename an uploaded document's displayed name (leaves the file on disk untouched)
  const [renameFileDialogOpen, setRenameFileDialogOpen] = useState(false);
  const [renameFileName, setRenameFileName] = useState('');
  const [fileToRename, setFileToRename] = useState(null);
  const [renameFileSaving, setRenameFileSaving] = useState(false);


  const [folderList, setFolderList] = useState(DEFAULT_FOLDERS);



// 🎯 Define the missing variable
const MAGISTRATE_OFFICE_OPTIONS = [
    { label: "Pretoria (Tshwane)", province: "Gauteng" },
    { label: "Not applicable", province: "N/A" },
    { label: "Johannesburg", province: "Gauteng" },
    { label: "Randburg", province: "Gauteng" },
    { label: "Soweto", province: "Gauteng" },
    { label: "Germiston (Ekurhuleni)", province: "Gauteng" },
    { label: "Kempton Park", province: "Gauteng" },
    { label: "Benoni", province: "Gauteng" },
    { label: "Krugersdorp", province: "Gauteng" },
    { label: "Cape Town", province: "Western Cape" },
    { label: "Bellville", province: "Western Cape" },
    { label: "Wynberg", province: "Western Cape" },
    { label: "Khayelitsha", province: "Western Cape" },
    { label: "Durban (eThekwini)", province: "KwaZulu-Natal" },
    { label: "Pinetown", province: "KwaZulu-Natal" },
    { label: "Verulam", province: "KwaZulu-Natal" },
    { label: "Pietermaritzburg", province: "KwaZulu-Natal" },
    { label: "Gqeberha (Nelson Mandela Bay)", province: "Eastern Cape" },
    { label: "East London (Buffalo City)", province: "Eastern Cape" },
    { label: "Mthatha", province: "Eastern Cape" },
    { label: "Bloemfontein (Mangaung)", province: "Free State" },
    { label: "Welkom", province: "Free State" },
    { label: "Polokwane", province: "Limpopo" },
    { label: "Mbombela (Nelspruit)", province: "Mpumalanga" },
    { label: "Middelburg", province: "Mpumalanga" },
    { label: "Kimberley", province: "Northern Cape" },
    { label: "Mahikeng", province: "North West" }
].sort((a, b) => a.label.localeCompare(b.label));

const HIGH_COURT_OPTIONS = [
  'Eastern Cape Division, Makhanda',
  'Eastern Cape Local Division, Bhisho',
  'Eastern Cape Local Division, East London',
  'Eastern Cape Local Division, Gqeberha (Port Elizabeth)',
  'Free State Division, Bloemfontein',
  'Gauteng Division, Pretoria (Main)',
  'Gauteng Local Division, Johannesburg',
  'KwaZulu-Natal Division, Pietermaritzburg',
  'KwaZulu-Natal Local Division, Durban',
  'Limpopo Division, Polokwane',
  'Mpumalanga Division, Mbombela (Nelspruit)',
  'Northern Cape Division, Kimberley',
  'North West Division, Mahikeng',
  'Western Cape Division, Cape Town',
  'Mpumalanga Division, Middelburg',
];

const AFU_OFFICE_OPTIONS = [
    { value: 'GautengPretoria', label: 'Gauteng - Pretoria (Head Office/Region)' },
    { value: 'GautengJohannesburg', label: 'Gauteng - Johannesburg (Region)' },
    { value: 'WesternCapeCapeTown', label: 'Western Cape - Cape Town' },
    { value: 'KwaZuluNatalDurban', label: 'KwaZulu-Natal - Durban' },
    { value: 'FreeStateBloemfontein', label: 'Free State - Bloemfontein' },
    { value: 'EasternCapePortElizabeth', label: 'Eastern Cape - Gqeberha (Port Elizabeth)' },
    { value: 'EasternCapeEastLondon', label: 'Eastern Cape - East London' },
    { value: 'LimpopoPolokwane', label: 'Limpopo - Polokwane' },
    { value: 'MpumalangaNelspruit', label: 'Mpumalanga - Nelspruit' },
    { value: 'MpumalangaMiddelburg', label: 'Mpumalanga - Middelburg' },
    { value: 'NorthernCapeKimberley', label: 'Northern Cape - Kimberley' },
    { value: 'NorthWestMafikeng', label: 'North West - Mahikeng / Mmabatho' },
];

const COMMON_CAUSES_OF_ACTION = [
    "Monies Lent and Advanced",
    "Goods Sold and Delivered",
    "Services Rendered",
    "Professional Fees",
    "Rent Arrears",
    "Damages",
    "Breach of Contract",
    "Acknowledgement of Debt",
    "Overdraft Facility",
    "Credit Card Debt",
    "Personal Loan",
    "Suretyship",
    "Other"
];

  const isNPAClassification = formData.estateClassification === 'NPA' || formData.estateClassification === 'Npa Matters' || formData.estateClassification === 'Curator Appointments';

  // 2. Define the dynamic array of visible tabs (NPA tab is NEVER added here)
    const visibleTabs = [
        { label: "Estate Information" },
        ...(!isNPAClassification ? [{ label: "Meetings" }] : []),
        ...(isNPAClassification ? [{ label: "Curator's Report" }] : []),
        { label: "Creditors" },
        { label: "Assets" },
        { label: "Debtors" },
        ...(!isNPAClassification ? [{ label: "L&D Account" }] : []),
        ...(isNPAClassification ? [{ label: "Draft Accounts" }, { label: "Final Accounts" }] : []),
        // 7.7: Enquiry tab confidentiality - hidden from guest (outside) users entirely
        ...((!isNPAClassification && user?.role !== 'guest') ? [{ label: "Enquiry" }] : []),
        { label: "Asset Insurance" },
        { label: "Estate Account" },
        { label: "Documents" },
        { label: "Task" },
    ];
  
  // 3. Define the correct calculated indices based on the resulting array structure
  // These are essential for mapping the content blocks correctly.
  const MEETINGS_INDEX = visibleTabs.findIndex(tab => tab.label === 'Meetings');
  const CURATOR_REPORT_INDEX = visibleTabs.findIndex(tab => tab.label === "Curator's Report");
  const CLAIMS_INDEX = visibleTabs.findIndex(tab => tab.label === 'Creditors');
    const ASSETS_INDEX = visibleTabs.findIndex(tab => tab.label === 'Assets');
  const DEBTORS_INDEX = visibleTabs.findIndex(tab => tab.label === 'Debtors');
    const LD_ACCOUNT_INDEX = visibleTabs.findIndex(tab => tab.label === 'L&D Account');
    const DRAFT_ACCOUNTS_INDEX = visibleTabs.findIndex(tab => tab.label === 'Draft Accounts');
    const FINAL_ACCOUNTS_INDEX = visibleTabs.findIndex(tab => tab.label === 'Final Accounts');
    const ENQUIRY_INDEX = visibleTabs.findIndex(tab => tab.label === 'Enquiry');
  const ASSET_INSURANCE_INDEX = visibleTabs.findIndex(tab => tab.label === 'Asset Insurance');
    const ESTATE_ACCOUNT_INDEX = visibleTabs.findIndex(tab => tab.label === 'Estate Account');
  const DOCUMENTS_INDEX = visibleTabs.findIndex(tab => tab.label === 'Documents');
    const TASKS_INDEX = visibleTabs.findIndex(tab => tab.label === 'Task');
 

  const containerStyle = {
    border: '2px solid',
    borderColor: isDarkMode ? '#555' : '#ccc',
    padding: 2,
    borderRadius: 2,
    marginBottom: 2,
    boxShadow: 2,
    backgroundColor: isDarkMode ? '#1e1e1e' : '#fff',
    color: isDarkMode ? '#f0f0f0' : '#000'
  };

  

  

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.get('https://demo.insollex.com/api/user', { withCredentials: true });

        // Defensive check
        if (typeof res.data !== 'object' || res.data === null) {
          console.error("Invalid user data received:", res.data);
          setUser(null);
          return;
        }

        // Optional: additional checks
        if (!res.data.role) {
          console.warn("User has no role defined. Treating as guest.");
          res.data.role = "guest";
        }

        setUser(res.data);
      } catch (err) {
        console.error('Could not fetch user', err);
        setUser(null);
      }
    };

    fetchUser();
  }, []);


 useEffect(() => {
    setAutoSaveStatus('');
    const fetchMatter = async () => {
        if (!id) {
            setError("Invalid ID provided");
            setLoading(false);
            return;
        }

        try {
            setLoading(true);
            let data;

            if (token) {
                const response = await fetch(`https://demo.insollex.com/api/matter-public/${id}?token=${token}`);
                setIsInvitedUser(true);
                if (!response.ok) throw new Error("Invite link is invalid or expired");
                const inviteData = await response.json();
                data = inviteData.matter;
            } else {
                const url = `https://demo.insollex.com/api/legal-matter/${id}`;
                const response = await fetch(url);
                if (!response.ok) throw new Error("Failed to fetch matter data");
                const result = await response.json();
                data = result.matter || result;
            }

            const classification = data.estateClassification || "";

            // 🛠️ FIX 1: Format date fields for <input type="date"> and handle nulls
            const dateFields = [
                'provisionalLiquidationDate', 'finalLiquidationDate',
                'provisionalAppointmentDate', 'finalAppointmentDate',
                'reductionRequestDate', 'reductionAllowedDate', 'dischargeDate',
                'acceptanceLetterDate', 'preOrderProvDate', 'preOrderFinalDate',
                'forfeitureOrderDate', 'resOrderProvDate', 'resOrderFinalDate',
                'confiscationOrderDate', 'realisationOrderDate', 'policyRenewalDate',
                'reductionIncreaseDate', 'cm26liqDate', 'anticipationOrderDate',
                'letterOfCuratorshipDate', 'setAsideDate', 'notProceedingDate'
            ];
            
            dateFields.forEach(field => { 
                if (data[field]) {
                    data[field] = formatDate(data[field]); 
                } else {
                    data[field] = ''; // Ensure nulls become empty strings for inputs
                }
            });
            
            const parseArray = (field) => {
                if (Array.isArray(field)) return field;
                if (typeof field === 'string') {
                    try { return JSON.parse(field); } catch(e) { return []; }
                }
                return [];
            };

            // 🛠️ FIX 2: Dynamic Trustee Row Initialization
            // This scans the data and sets the correct number of rows to display
            let highestTrusteeIndex = 0;
            for (let i = 1; i <= 8; i++) {
                if (data[`trustee${i}FirmName`] || data[`trustee${i}FullName`] || data[`trustee${i}Email`] || data[`trustee${i}Telephone`]) {
                    highestTrusteeIndex = i;
                }
            }
            setNumTrustees(highestTrusteeIndex);

            const bondEntriesArray = ensureBondEntriesFormat(data);
            
            // 🛠️ FIX 3: Sanitize data to prevent "null" from overwriting UI state
            const sanitizedData = {
                ...data,
                comment: data.comment || '',
                estateClassification: classification,
                bondEntries: bondEntriesArray,
                stakeholders: parseArray(data.stakeholders),
                commentsList: parseArray(data.commentsList),
                requisitions: parseArray(data.requisitions),
                respondents: parseArray(data.respondents),
                anticipationOrderRespondentIds: parseArray(data.anticipationOrderRespondentIds),
                confiscationOrderRespondentIds: parseArray(data.confiscationOrderRespondentIds),
                curatorReports: parseArray(data.curatorReports),
                ldExtensions: parseArray(data.ldExtensions),
                claimsList: parseArray(data.claimsList),
                debtorsList: parseArray(data.debtorsList),
                assetInsuranceList: parseArray(data.assetInsuranceList),
                enquiriesList: parseArray(data.enquiriesList),
                applicantIsDebtor: data.applicantIsDebtor === true || data.applicantIsDebtor === "1" || data.applicantIsDebtor === 1 || String(data.applicantIsDebtor) === "true",
                tasksList: parseArray(data.tasksList),
                bankAccounts: parseArray(data.bankAccounts),
                hasProvisionalOrders: data.hasProvisionalOrders === undefined || data.hasProvisionalOrders === null ? true : (data.hasProvisionalOrders === true || data.hasProvisionalOrders === "1" || data.hasProvisionalOrders === 1 || String(data.hasProvisionalOrders) === "true"),
            };

            setMatter(sanitizedData);

            setUpdatedMatter({
                ...sanitizedData
            });

            // The formData update below is the fetch populating state, not a user edit -
            // don't let it trigger an auto-save of data we just loaded.
            skipNextAutoSaveRef.current = true;
            setFormData(prev => ({
                ...prev,
                ...sanitizedData
            }));

        } catch (error) {
            console.error("Error fetching matter data:", error);
            setError(error.message || "Failed to fetch matter data.");
        } finally {
            setLoading(false);
        }
    };

    fetchMatter();
}, [id, token]);

  // 🛠️ FIX: Auto-redirect to Deceased Estate Page if classification matches
  useEffect(() => {
      if (matter && !token) {
          const classification = matter.estateClassification?.trim();
          if (classification === 'Deceased Estates' || classification === 'Deceased Estate') {
              navigate(`/deceased-estate/${id}`, { replace: true });
          }
      }
  }, [matter, navigate, id, token]);


  // Normalize estate classification

  // 🛠️ Updated State: Manages the number of trustee rows. Starts at 1.
  const [numTrustees, setNumTrustees] = useState(0);
    
  // Helper array to generate indices for mapping

  // Helper function to aggregate emails for the "Email All" button
  const getEmails = () => {
      const emails = [];
      for (let i = 1; i <= numTrustees; i++) {
          const emailField = formData[`trustee${i}Email`];
          if (emailField) {
              const parsed = emailField.split(/[,;]+/).map(e => e.trim()).filter(e => e);
              emails.push(...parsed);
          }
      }
      return emails;
  };
  




  // Enable editing mode

 const handleSaveData = async (options = {}) => {
    const { silent = false } = options;

    if (!user || user?.role === 'guest' || !isEditingMode) {
      if (!silent) {
        setSnackbarMessage("You are not allowed to save data.");
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
      return;
    }

    if (!id) {
      if (!silent) {
        setSnackbarMessage("Error: Missing matter ID!");
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
      return;
    }

    // NPA / Curator matters are opened before the Master issues a reference, so don't
    // block the update on a missing Master Reference for them. For a silent auto-save,
    // just skip quietly rather than interrupting the user with an error while they're
    // still mid-edit elsewhere on the page - the manual Save button still surfaces this.
    if (!formData.estateNo && !isNPAClassification) {
      if (!silent) {
        setSnackbarMessage("Error: Missing estate number!");
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
      return;
    }

    if (silent) setAutoSaveStatus('saving');
    setIsLoading(true);

    try {
      const url = `https://demo.insollex.com/api/legal-matter/${id}`;

      // 🎯 1. Destructure to separate relational data from the flat payload
      // Added stakeholders, commentsList, and requisitions here
      const { 
          deceasedEstate, 
          documents, 
          transaction, 
          respondents: currentRespondents, 
          bondEntries: currentBondEntries, 
          stakeholders: currentStakeholders,
          commentsList: currentComments,
          requisitions: currentReqs,
          ldExtensions: currentLdExtensions,
          claimsList: currentClaimsList,
          debtorsList: currentDebtorsList,
          assetInsuranceList: currentAssetInsuranceList,
          enquiriesList: currentEnquiriesList,
          tasksList: currentTasksList,
          bankAccounts: currentBankAccounts,
          ...payload 
      } = formData;

      const response = await fetch(url, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            ...payload,
            respondents: currentRespondents || [],
            bondEntries: currentBondEntries || [],
            stakeholders: currentStakeholders || [], // 🆕 Save Directors/Members
            commentsList: currentComments || [],     // 🆕 Save Task Log
            requisitions: currentReqs || [],
            ldExtensions: currentLdExtensions || [],
            claimsList: currentClaimsList || [],
            debtorsList: currentDebtorsList || [],
            assetInsuranceList: currentAssetInsuranceList || [],
            enquiriesList: currentEnquiriesList || [],
            tasksList: currentTasksList || [],
            bankAccounts: currentBankAccounts || [],
        }), 
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to save: ${errorText}`);
      }

      const data = await response.json();

      if (data.updatedMatter) {
        // We use the flat response from our updated buildFlatMatterResponse helper
        const updated = data.updatedMatter;
        
        const dateFields = [
            'provisionalLiquidationDate', 'finalLiquidationDate',
            'provisionalAppointmentDate', 'finalAppointmentDate',
            'reductionRequestDate', 'reductionAllowedDate', 'dischargeDate',
            'acceptanceLetterDate', 'preOrderProvDate', 'preOrderFinalDate',
            'forfeitureOrderDate', 'resOrderProvDate', 'resOrderFinalDate',
            'confiscationOrderDate', 'realisationOrderDate', 'policyRenewalDate',
            'reductionIncreaseDate', 'bankAccountOpenedDate', 'bankAccountClosedDate',
            'cm26liqDate', 'letterOfCuratorshipDate', 'setAsideDate', 'notProceedingDate'
        ];
        
        dateFields.forEach(field => { 
            updated[field] = updated[field] ? formatDate(updated[field]) : '';
        });
        
        const parseArray = (field, fallback) => {
            if (Array.isArray(field)) return field;
            if (typeof field === 'string') {
                try { return JSON.parse(field); } catch(e) { return fallback; }
            }
            return fallback;
        };

        // 🎯 2. Sanitize incoming data to ensure NO 'null' values reach the inputs
        const freshData = {
            ...updated,
            // Ensure strings aren't null
            comment: updated.comment || '',
            applicantName: updated.applicantName || '',
            attorneyName: updated.attorneyName || '',

            // 🎯 3. Ensure Arrays are preserved
            bondEntries: parseArray(updated.bondEntries, currentBondEntries || []),
            stakeholders: parseArray(updated.stakeholders, currentStakeholders || []),
            commentsList: parseArray(updated.commentsList, currentComments || []),
            requisitions: parseArray(updated.requisitions, currentReqs || []),
            respondents: parseArray(updated.respondents, currentRespondents || []),
            ldExtensions: parseArray(updated.ldExtensions, currentLdExtensions || []),
            claimsList: parseArray(updated.claimsList, currentClaimsList || []),
            debtorsList: parseArray(updated.debtorsList, currentDebtorsList || []),
            assetInsuranceList: parseArray(updated.assetInsuranceList, currentAssetInsuranceList || []),
            enquiriesList: parseArray(updated.enquiriesList, currentEnquiriesList || []),
            applicantIsDebtor: updated.applicantIsDebtor === true || updated.applicantIsDebtor === "1" || updated.applicantIsDebtor === 1 || String(updated.applicantIsDebtor) === "true",
            tasksList: parseArray(updated.tasksList, currentTasksList || []),
            bankAccounts: parseArray(updated.bankAccounts, currentBankAccounts || []),
            activeLedgers: parseArray(updated.activeLedgers, ['Estate']),
        };

        // 🎯 4. Update both state objects
        // This is the save response syncing back into formData, not a new user edit -
        // don't let it re-trigger auto-save (that would loop forever).
        skipNextAutoSaveRef.current = true;
        setFormData(prev => ({ ...prev, ...freshData }));
        setUpdatedMatter(prev => ({ ...prev, ...freshData }));
        
        // 🎯 5. Re-sync the number of Trustee rows
        let highestTrustee = 0;
        for (let i = 1; i <= 8; i++) {
            if (freshData[`trustee${i}FirmName`] || freshData[`trustee${i}FullName`] || freshData[`trustee${i}Email`]) {
                highestTrustee = i;
            }
        }
        setNumTrustees(highestTrustee);

        if (silent) {
          setAutoSaveStatus('saved');
        } else {
          setSnackbarMessage("Estate data updated successfully!");
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
        }
      }
    } catch (error) {
      console.error('Save Error:', error);
      if (silent) setAutoSaveStatus('');
      setSnackbarMessage(error.message || 'Failed to save updates.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setIsLoading(false);
    }
};

  // Auto-save: debounce edits to formData and silently save a couple of seconds after the
  // user stops typing/changing a field, so leaving without clicking "Update Estate" doesn't
  // lose work. skipNextAutoSaveRef filters out state changes that come from the fetch or
  // from the save itself, so only real user edits schedule a save.
  useEffect(() => {
    if (skipNextAutoSaveRef.current) {
      skipNextAutoSaveRef.current = false;
      return;
    }
    if (!isEditingMode || !user || user?.role === 'guest' || !id) return;

    if (autoSaveTimerRef.current) clearTimeout(autoSaveTimerRef.current);
    autoSaveTimerRef.current = setTimeout(() => {
      handleSaveData({ silent: true });
    }, 2500);

    return () => {
      if (autoSaveTimerRef.current) clearTimeout(autoSaveTimerRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  // Fade the "Autosaved" indicator back out a few seconds after it appears.
  useEffect(() => {
    if (autoSaveStatus !== 'saved') return;
    const t = setTimeout(() => setAutoSaveStatus(''), 4000);
    return () => clearTimeout(t);
  }, [autoSaveStatus]);

  const handleCashbookSummary = (summary) => {
    setFormData((prev) => ({ ...prev, ...summary }));
  };


  // Handle Snackbar close
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isDragging) setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    const files = Array.from(e.dataTransfer.files).map(file => ({ file }));
    if (files.length > 0) {
        setSelectedFiles(prev => [...prev, ...files]);
    }
  };


  const handleFieldChange = (e) => {
    const { name, value, type, checked } = e.target;

    // 1. Handle Checkboxes
    // Use 'checked' if available (native event), otherwise fallback to 'value' (synthetic event)
    let finalValue = type === 'checkbox' ? (checked !== undefined ? checked : value) : value;

    // 2. Handle Numeric/Cashbook Fields (🎯 New addition)
    // If the field name starts with 'cashbookTotal' or 'inhouseTotal', 
    // we ensure it's a valid number string or empty.
    const isNumericField = name.startsWith('cashbookTotal') || name.startsWith('inhouseTotal') || name === 'cashbookBalance';
    
    if (isNumericField) {
        // Remove any non-numeric characters except the decimal point
        finalValue = value.replace(/[^0-9.]/g, '');
    }

    // 3. Prevent Unnecessary Re-renders & Update State
    const updateState = (prev) => {
        if (prev[name] === finalValue) return prev;
        return { ...prev, [name]: finalValue };
    };

    setFormData(updateState);
    setUpdatedMatter(updateState);
};

// --- HANDLERS FOR INLINE COMMENT EDITING ---
const handleStartEditComment = (comment) => {
    setEditingCommentId(comment.id);
    setEditingCommentText(comment.text);
};

const handleCancelEditComment = () => {
    setEditingCommentId(null);
    setEditingCommentText('');
};

const handleSaveCommentEdit = () => {
    if (!editingCommentId) return;

    const updatedList = formData.commentsList.map(c => {
        if (c.id === editingCommentId) {
            // Update text and add an '(edited)' tag to the date for clarity
            return { ...c, text: editingCommentText, date: `${new Date().toLocaleString('en-ZA')} (edited)` };
        }
        return c;
    });

    handleFieldChange({ target: { name: 'commentsList', value: updatedList, type: 'array' } });

    // Reset editing state
    handleCancelEditComment();
};

const handleDeleteComment = (commentId) => {
    const filtered = formData.commentsList.filter(c => c.id !== commentId);
    handleFieldChange({ target: { name: 'commentsList', value: filtered, type: 'array' } });
};


const handleOpenInsolventForm = (index = null) => {
    if (index !== null) {
        setInsolventForm(formData.stakeholders[index]);
        setEditingInsolventIndex(index);
    } else {
        setInsolventForm({
            id: Date.now(), fullName: '', idNumber: '', status: 'Alive', maritalStatus: 'Single', phone: '', email: '', address: '', taxNo: '', vatNo: ''
        });
        setEditingInsolventIndex(null);
    }
    setInsolventFormOpen(true);
};

const handleCloseInsolventForm = () => {
    setInsolventFormOpen(false);
    setEditingInsolventIndex(null);
};

const handleSaveInsolvent = () => {
    const updatedList = [...(formData.stakeholders || [])];
    if (editingInsolventIndex !== null) {
        updatedList[editingInsolventIndex] = insolventForm;
    } else {
        updatedList.push(insolventForm);
    }
    handleFieldChange({ target: { name: 'stakeholders', value: updatedList, type: 'array' } });
    handleCloseInsolventForm();
};

const handleOpenTrusteeForm = (index = null) => {
    if (index !== null) {
        setTrusteeForm({
            firmName: formData[`trustee${index}FirmName`] || '',
            fullName: formData[`trustee${index}FullName`] || '',
            phone: formData[`trustee${index}Telephone`] || '',
            email: formData[`trustee${index}Email`] || '',
                vatRegistered: formData[`trustee${index}VatRegistered`] === true || formData[`trustee${index}VatRegistered`] === "1" || formData[`trustee${index}VatRegistered`] === 1 || String(formData[`trustee${index}VatRegistered`]) === "true",
                    vatNumber: formData[`trustee${index}VatNumber`] || '',
                    saveToDirectory: false
        });
        setEditingTrusteeIndex(index);
    } else {
        setTrusteeForm({
                    firmName: '', fullName: '', phone: '', email: '', vatRegistered: false, vatNumber: '', saveToDirectory: false
        });
        setEditingTrusteeIndex(numTrustees < 8 ? numTrustees + 1 : 8);
    }
    setTrusteeFormOpen(true);
};

const handleCloseTrusteeForm = () => {
    setTrusteeFormOpen(false);
    setEditingTrusteeIndex(null);
};

const handleOpenDirMemForm = (index = null) => {
    if (index !== null) {
        setDirMemForm(formData.stakeholders[index]);
        setEditingDirMemIndex(index);
    } else {
        setDirMemForm({ id: Date.now(), fullName: '', idNumber: '', status: 'Alive', phone: '', email: '', address: '' });
        setEditingDirMemIndex(null);
    }
    setDirMemFormOpen(true);
};

const handleCloseDirMemForm = () => {
    setDirMemFormOpen(false);
    setEditingDirMemIndex(null);
};

const handleSaveDirMem = () => {
    const updatedList = [...(formData.stakeholders || [])];
    if (editingDirMemIndex !== null) updatedList[editingDirMemIndex] = dirMemForm;
    else updatedList.push(dirMemForm);
    handleFieldChange({ target: { name: 'stakeholders', value: updatedList, type: 'array' } });
    handleCloseDirMemForm();
};

const handleSaveTrustee = () => {
    let indexToSave = editingTrusteeIndex;
    if (!indexToSave) {
        indexToSave = numTrustees < 8 ? numTrustees + 1 : 8;
    }

    const updates = {
        [`trustee${indexToSave}FirmName`]: trusteeForm.firmName,
        [`trustee${indexToSave}FullName`]: trusteeForm.fullName,
        [`trustee${indexToSave}Telephone`]: trusteeForm.phone,
        [`trustee${indexToSave}Email`]: trusteeForm.email,
        [`trustee${indexToSave}VatRegistered`]: trusteeForm.vatRegistered,
        [`trustee${indexToSave}VatNumber`]: trusteeForm.vatNumber,
    };

    const updateState = (prev) => ({ ...prev, ...updates });
    setFormData(updateState);
    setUpdatedMatter(updateState);

    if (indexToSave > numTrustees) {
        setNumTrustees(indexToSave);
    }

    // Save to directory logic
    if (trusteeForm.saveToDirectory && trusteeForm.fullName) {
        const newDir = [...trusteeDirectory];
        const existingIdx = newDir.findIndex(t => t.fullName === trusteeForm.fullName);
        const contactToSave = {
            firmName: trusteeForm.firmName,
            fullName: trusteeForm.fullName,
            phone: trusteeForm.phone,
            email: trusteeForm.email,
            vatRegistered: trusteeForm.vatRegistered,
            vatNumber: trusteeForm.vatNumber
        };
        if (existingIdx >= 0) newDir[existingIdx] = contactToSave;
        else newDir.push(contactToSave);
        setTrusteeDirectory(newDir);
        localStorage.setItem('insollex_trustee_directory', JSON.stringify(newDir));
    }

    handleCloseTrusteeForm();
};

const handleDeleteTrustee = (index) => {
    if (window.confirm("Are you sure you want to delete this entry?")) {
        const updates = {};
        for (let i = index; i < 8; i++) {
            updates[`trustee${i}FirmName`] = formData[`trustee${i+1}FirmName`] || '';
            updates[`trustee${i}FullName`] = formData[`trustee${i+1}FullName`] || '';
            updates[`trustee${i}Telephone`] = formData[`trustee${i+1}Telephone`] || '';
            updates[`trustee${i}Email`] = formData[`trustee${i+1}Email`] || '';
            updates[`trustee${i}VatRegistered`] = formData[`trustee${i+1}VatRegistered`] || false;
            updates[`trustee${i}VatNumber`] = formData[`trustee${i+1}VatNumber`] || '';
        }
        updates[`trustee8FirmName`] = '';
        updates[`trustee8FullName`] = '';
        updates[`trustee8Telephone`] = '';
        updates[`trustee8Email`] = '';
        updates[`trustee8VatRegistered`] = false;
        updates[`trustee8VatNumber`] = '';
        
        const updateState = (prev) => ({ ...prev, ...updates });
        setFormData(updateState);
        setUpdatedMatter(updateState);
        setNumTrustees(prev => prev > 0 ? prev - 1 : 0);
    }
};

const handleOpenRespondentForm = (respondent = null, presetType = 'Respondent') => {
    if (respondent) {
        setRespondentForm(respondent);
        setEditingRespondentId(respondent.id);
    } else {
        setRespondentForm({
            id: Date.now() + Math.random(), name: '', idNo: '', contactDetails: '', emailAddress: '', maritalStatus: 'Single', type: presetType, entityType: 'Individual'
        });
        setEditingRespondentId(null);
    }
    setRespondentFormOpen(true);
};

const handleCloseRespondentForm = () => {
    setRespondentFormOpen(false);
    setEditingRespondentId(null);
};

const handleSaveRespondent = () => {
    const updatedList = [...(formData.respondents || [])];
    // roleLabel ("1st Defendant" etc.) is derived for display only - never store it.
    const { roleLabel, ...cleanRespondent } = respondentForm;
    if (editingRespondentId !== null) {
        const index = updatedList.findIndex(r => r.id === editingRespondentId);
        if (index !== -1) updatedList[index] = cleanRespondent;
    } else {
        updatedList.push(cleanRespondent);
    }
    handleFieldChange({ target: { name: 'respondents', value: updatedList, type: 'array' } });
    handleCloseRespondentForm();
};

const handleDeleteRespondent = (id) => {
    if (window.confirm("Are you sure you want to delete this respondent?")) {
        const newEntries = (formData.respondents || []).filter(entry => entry.id !== id);
        handleFieldChange({ target: { name: 'respondents', value: newEntries, type: 'array' } });
    }
};

const handleRequisitionChange = (index, field, value) => {
    const updatedRequisitions = [...(formData.requisitions || [])];
    let finalValue = value;

    // Numeric cleaning for amount
    if (field === 'amount') {
        finalValue = value.replace(/[^0-9.]/g, '');
    }

    updatedRequisitions[index] = { 
        ...updatedRequisitions[index], 
        [field]: finalValue 
    };

    // 🎯 NEW: Auto-generate Renewal Date when Requisition Date changes
    if (field === 'dateOfRequisition' && finalValue) {
        const date = new Date(finalValue);
        date.setDate(date.getDate() + 20);

        const dayOfWeek = date.getDay(); // 0 = Sunday, 6 = Saturday
        
        if (dayOfWeek === 6) { 
            // 💡 Rule: Saturday -> Friday
            date.setDate(date.getDate() - 1); 
        } else if (dayOfWeek === 0) { 
            // 💡 Rule: Sunday -> Monday
            date.setDate(date.getDate() + 1); 
        }

        updatedRequisitions[index].renewalDate = date.toISOString().split('T')[0];
    }

    const updateState = (prev) => ({ ...prev, requisitions: updatedRequisitions });
    setFormData(updateState);
    setUpdatedMatter(updateState);
};




  // Fetching documents logic - Automatically choose old or new database
  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const url = `https://demo.insollex.com/api/legal-matter/${id}/documents`;

        const response = await fetch(url);
        if (!response.ok) throw new Error(`Failed to fetch documents. Status: ${response.status}`);

        const documentsData = await response.json();
        setDocuments(documentsData);

        // Optional: initialize folders if documents already have folder assignments
        // Merge default folders with any custom folders from existing documents
        const existingFolders = [...new Set(documentsData.map(d => d.folder).filter(Boolean))];
        setFolderList(prev => [...prev, ...existingFolders.filter(f => !prev.includes(f))]);
        setFolderList(prev => [...new Set([...prev, ...existingFolders])]);
      } catch (error) {
        console.error('Error fetching documents:', error);
      }
    };

    fetchDocuments();
  }, [id]);




  const handleFileUpload = async (folder = null, isPublic = false, directFiles = []) => {
  const rawSources = directFiles.length > 0 ? directFiles : selectedFiles;
  
  const filesToUpload = rawSources
    .map(item => (item instanceof File ? item : item?.file || item))
    .filter(file => file instanceof File);

  if (!filesToUpload || filesToUpload.length === 0) {
    setSnackbarMessage('Please select at least one file!');
    setSnackbarSeverity('warning');
    setSnackbarOpen(true);
    return;
  }

  setUploading(true);
  setUploadProgress(0);

  const formData = new FormData();
  formData.append('folder', folder || '');
  formData.append('isPublic', isPublic ? 'true' : 'false');

  filesToUpload.forEach((file) => {
    formData.append('documents', file, file.name);
  });

  try {
    const url = `https://demo.insollex.com/api/legal-matter/${id}/uploads`;
    const response = await axios.post(url, formData, {
      headers: {
        'x-user-email': user?.emailAddress || user?.email || '',
        'x-user-role': user?.role || '',
      },
      onUploadProgress: (e) => {
        const percent = e.total ? Math.round((e.loaded * 100) / e.total) : 0;
        setUploadProgress(percent);
      },
    });

    const newDocuments = response.data?.files || [];

    if (newDocuments.length > 0) {
      // 🎯 Store the server's normalized documents (which contain the real server filename & filepath)
      setDocuments((prev) =>
        prev.concat(
          newDocuments.map((doc) => {
            // Convert backslashes to forward slashes immediately
            const cleanPath = (doc.filepath || '').replace(/\\/g, '/');
            return {
              ...doc,
              filepath: cleanPath,
              folder: folder || doc.folder,
              isPublic,
            };
          })
        )
      );

      // Auto-preview the newly uploaded file using server's saved path
      handleOpenPreview(newDocuments[0]);

      setSnackbarMessage('Documents uploaded successfully!');
      setSnackbarSeverity('success');
    } else {
      setSnackbarMessage('Upload completed but no documents returned.');
      setSnackbarSeverity('warning');
    }

    setSnackbarOpen(true);
    setSelectedFiles([]);
    if (hiddenFileInput.current) hiddenFileInput.current.value = null;
  } catch (error) {
    console.error('Upload error:', error);
    setSnackbarMessage('Failed to upload documents.');
    setSnackbarSeverity('error');
    setSnackbarOpen(true);
  } finally {
    setUploading(false);
    setUploadProgress(0);
  }
};

const toggleFolder = (folder) => {
  setOpenFolders(prev => ({ ...prev, [folder]: !prev[folder] }));
  setSelectedFolder(prev => (prev === folder ? null : folder));
};

const handleOpenNewFolderDialog = (isSub = false) => {
  setIsSubfolderDialog(isSub);
  if (isSub && folderList.length > 0) {
    setParentForNewFolder(folderList[0]);
  } else {
    setParentForNewFolder('');
  }
  setNewFolderDialogOpen(true);
};

const handleCloseNewFolderDialog = () => {
  setNewFolderDialogOpen(false);
  setNewFolderName('');
};

const handleCreateFolder = () => {
  const parentPath = isSubfolderDialog ? parentForNewFolder : '';
  const newPath = parentPath ? `${parentPath}/${newFolderName.trim()}` : newFolderName.trim();

  if (newFolderName.trim() && !folderList.includes(newPath)) {
    setFolderList([...folderList, newPath]);
    handleCloseNewFolderDialog();
    setSnackbarMessage('Folder created successfully.');
    setSnackbarSeverity('success');
    setSnackbarOpen(true);
  } else {
    setSnackbarMessage('Folder name is empty or already exists in this location.');
    setSnackbarSeverity('warning');
    setSnackbarOpen(true);
  }
};

const handleOpenRenameFolderDialog = (folder, e) => {
  e.stopPropagation();
  setFolderToRename(folder);
  setRenameFolderName(folder);
  setRenameFolderDialogOpen(true);
};

const handleCloseRenameFolderDialog = () => {
  setRenameFolderDialogOpen(false);
  setRenameFolderName('');
  setFolderToRename(null);
};

const handleRenameFolderSubmit = async () => {
  if (!folderToRename || !renameFolderName.trim()) {
    setSnackbarMessage('Invalid folder name.');
    setSnackbarSeverity('warning');
    setSnackbarOpen(true);
    return;
  }

  const oldPath = folderToRename;
  const newName = renameFolderName.trim();
  const pathParts = oldPath.split('/');
  const oldName = pathParts.pop();

  if (newName === oldName) {
    handleCloseRenameFolderDialog();
    return;
  }

  const parentPath = pathParts.join('/');
  const newPath = parentPath ? `${parentPath}/${newName}` : newName;

  if (folderList.some(f => f.toLowerCase() === newPath.toLowerCase())) {
    setSnackbarMessage('A folder with that name already exists here.');
    setSnackbarSeverity('warning');
    setSnackbarOpen(true);
    return;
  }

  setFolderList(prevList => prevList.map(f => {
    if (f === oldPath) return newPath;
    if (f.startsWith(`${oldPath}/`)) return f.replace(oldPath, newPath);
    return f;
  }));

  setDocuments(prevDocs => prevDocs.map(doc => {
    if (doc.folder && doc.folder.startsWith(oldPath)) {
      return { ...doc, folder: doc.folder.replace(oldPath, newPath) };
    }
    return doc;
  }));

  setSnackbarMessage('Folder renamed locally. Save changes to persist document moves.');
  setSnackbarSeverity('info');
  setSnackbarOpen(true);
  handleCloseRenameFolderDialog();
};

// 🎯 10.1: Rename an uploaded document
const handleOpenRenameFileDialog = (file, e) => {
  if (e) e.stopPropagation();
  setFileToRename(file);
  setRenameFileName(file.filename || '');
  setRenameFileDialogOpen(true);
};

const handleCloseRenameFileDialog = () => {
  setRenameFileDialogOpen(false);
  setRenameFileName('');
  setFileToRename(null);
};

const handleRenameFileSubmit = async () => {
  if (!fileToRename || !renameFileName.trim()) {
    setSnackbarMessage('Please enter a document name.');
    setSnackbarSeverity('warning');
    setSnackbarOpen(true);
    return;
  }

  const fileId = fileToRename.id || fileToRename._id;
  if (!fileId) {
    setSnackbarMessage('Cannot rename this document - missing document ID.');
    setSnackbarSeverity('error');
    setSnackbarOpen(true);
    return;
  }

  setRenameFileSaving(true);
  try {
    const response = await axios.put(`/api/legal-matter/documents/${fileId}/rename`, {
      newFilename: renameFileName.trim(),
    });
    const updatedDoc = response.data?.document;

    // Reflect the new name locally without touching anything else about the file.
    setDocuments(prevDocs => prevDocs.map(doc =>
      (doc.id || doc._id) === fileId ? { ...doc, filename: updatedDoc?.filename || renameFileName.trim() } : doc
    ));

    setSnackbarMessage('Document renamed successfully.');
    setSnackbarSeverity('success');
    setSnackbarOpen(true);
    handleCloseRenameFileDialog();
  } catch (error) {
    console.error('Error renaming document:', error);
    setSnackbarMessage('Failed to rename document. Please try again.');
    setSnackbarSeverity('error');
    setSnackbarOpen(true);
  } finally {
    setRenameFileSaving(false);
  }
};

const handleDeleteFolder = (folderPath, e) => {
  e.stopPropagation();
  const filesInFolder = documents.filter(file => file.folder && file.folder.startsWith(folderPath));
  if (filesInFolder.length > 0) {
    setSnackbarMessage('Cannot delete folder: It contains files. Please delete or move the files first.');
    setSnackbarSeverity('warning');
    setSnackbarOpen(true);
    return;
  }
  if (window.confirm(`Are you sure you want to delete the folder '${folderPath}'?`)) {
    setFolderList(prev => prev.filter(f => f !== folderPath && !f.startsWith(`${folderPath}/`)));
    setSnackbarMessage('Folder deleted successfully.');
    setSnackbarSeverity('success');
    setSnackbarOpen(true);
  }
};

  // Trigger file input


  // Select files, optionally assign them to the currently selected folder
  const handleFileChange = (event) => {
    const files = Array.from(event.target.files).map(file => ({
      file, // native File object
    }));

    if (files.length > 0) {
      setSelectedFiles(prev => [...prev, ...files]); // accumulate files
    }
  };


 
  // Document Preview
const handleOpenPreview = (file) => {
  if (!file) return;

  // 1. Get raw path from server response (e.g., "uploads\Form_J29-CC(1).pdf",
  //    or a full server filesystem path for legacy/older records)
  const rawPath = file.filepath || file.path || file.filename || '';

  // 2-3. Normalize slashes and strip down to the "uploads/..." portion,
  //      regardless of whether a relative or absolute path was stored
  const cleanPath = getUploadsRelativePath(rawPath);

  // 4. Build full absolute HTTPS URL
  const fullUrl = cleanPath.startsWith('http')
    ? cleanPath
    : `https://demo.insollex.com/${cleanPath}`;

  console.log('Previewing Document Target URL:', fullUrl);

  // 5. Update state
  setSelectedDocument({
    ...file,
    filepath: fullUrl,
  });
};


  // Delete Document - For both the new and old database
  const handleDeleteClick = (filename) => {
    setSelectedFile(filename);
    setOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (folderList.includes(selectedFile)) {
      setSnackbarMessage('Folders cannot be deleted.');
      setSnackbarSeverity('warning');
      setSnackbarOpen(true);
      setOpen(false);
      return;
    }

    console.log(`Deleting document: ${selectedFile} for matter ID: ${id}`);
    try {
      const response = await fetch(`https://demo.insollex.com/api/legal-matter/${id}/documents/${selectedFile}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to delete document: ${errorText}`);
      }

      // Remove deleted document from state
      setDocuments((prevDocs) => prevDocs.filter((file) => file.filename !== selectedFile));

      // Clear preview if the deleted file is being shown
      if (selectedDocument?.filename === selectedFile) {
        setSelectedDocument(null);
      }

      setOpen(false);
      setSnackbarMessage('Document moved to Trash.');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
    } catch (error) {
      console.error('Error deleting document:', error);
      setSnackbarMessage(error.message);
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  const handleAssetsMenuClick = (event) => {
    setAssetsMenuAnchor(event.currentTarget);
  };
  
  const handleAssetsMenuClose = () => {
    setAssetsMenuAnchor(null);
  };


  
 return (
    <Box sx={{ padding: 2, position: 'relative' }}>

      {/* Loading / Error States */}
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <CircularProgress />
          <Typography variant="h6" sx={{ ml: 2 }}>Loading Matter Details...</Typography>
        </Box>
      ) : !matter ? (
        <Typography variant="h6">Matter not found</Typography>
      ) : (
        <React.Fragment>

          {/* BUTTON GROUP: TOP RIGHT ACTIONS */}
          <Box sx={{ position: 'absolute', top: 16, right: 16, zIndex: 10 }}>
            <Stack direction="row" spacing={1}>
              {/* Manage Master Info Button */}
              <Button 
                variant="outlined" 
                color="primary" 
                size="small"
                startIcon={<SettingsIcon />} 
                onClick={handleOpenMasterModal}
                sx={{ 
                  textTransform: 'none', 
                  fontWeight: 'bold',
                  backgroundColor: 'white',
                  '&:hover': { backgroundColor: '#f5f5f5' }
                }}
              >
                Manage Master Info
              </Button>

              {/* View/Edit Matter Info Button */}
              <Button 
                variant="outlined" 
                color="primary" 
                size="small"
                startIcon={<SettingsIcon />} 
                onClick={() => setOpenForm(true)}
                sx={{ 
                  textTransform: 'none', 
                  fontWeight: 'bold',
                  backgroundColor: 'white',
                  '&:hover': { backgroundColor: '#f5f5f5' }
                }}
              >
                View / Edit Matter Info
              </Button>
            </Stack>
          </Box>

          {openForm && (
            <MatterForm
              openForm={openForm}
              setOpenForm={setOpenForm}
              initialData={matter}
              onUpdateLegalMatter={(updated) => {
                // Already saved by MatterForm's own PUT - don't let syncing it back into
                // formData trigger a redundant auto-save.
                skipNextAutoSaveRef.current = true;
                setMatter(prev => ({ ...prev, ...updated }));
                setUpdatedMatter(prev => ({ ...prev, ...updated }));
                setFormData(prev => ({ ...prev, ...updated }));
              }}
            />
          )}

          {/* --- MASTER INFORMATION MODAL --- */}
          <Modal
            open={masterModalOpen}
            onClose={handleCloseMasterModal}
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <Box sx={{ bgcolor: 'background.paper', p: 4, borderRadius: 2, boxShadow: 24, width: 500 }}>
              <Typography variant="h6" sx={{ mb: 3, fontWeight: 'bold' }}>Master Information</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField 
                    select 
                    fullWidth 
                    label="Master Office" 
                    name="mastersOffice" 
                    value={formData.mastersOffice || ''} 
                    onChange={handleFieldChange}
                  >
                    {['Pretoria', 'Johannesburg', 'Cape Town', 'Bloemfontein', 'Grahamstown', 'Kimberley', 'Mmabatho', 'Pietermaritzburg', 'Polokwane', 'Mthatha', 'Bisho', 'Thohoyandou'].map(opt => <MenuItem key={opt} value={opt}>{opt}</MenuItem>)}
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField 
                    fullWidth 
                    label="Contact Person (Name & Surname)" 
                    name="masterContactPerson" 
                    value={formData.masterContactPerson || ''} 
                    onChange={handleFieldChange} 
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField 
                    fullWidth 
                    label="Email Address" 
                    name="masterContactEmail" 
                    value={formData.masterContactEmail || ''} 
                    onChange={handleFieldChange} 
                  />
                </Grid>
              </Grid>
              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                <Button onClick={handleCloseMasterModal} variant="contained">Close</Button>
              </Box>
            </Box>
          </Modal>

          {/* Matter/Estate name + EstateNo above the tabs */}
          {(matter?.matterName || estate?.EstateName || matter?.caseNumber || matter?.estateNo || estate?.estateNo) && (
            <Typography
              variant="h3"
              sx={{ mb: 2, textAlign: 'center', fontWeight: 'bold' }}
            >
              Estate – {matter?.matterName || estate?.EstateName}
              {matter?.caseNumber && ` | Case No – ${matter.caseNumber}`}
              {(matter?.estateNo || estate?.estateNo) && ` | Master Ref – ${matter?.estateNo || estate?.estateNo}`}
            </Typography>
          )}

          {/* Set Aside / Not Proceeding status banner - immediately visible regardless of tab */}
          {(formData.isSetAside || formData.isNotProceeding) && (
            <Alert severity="error" variant="filled" sx={{ mb: 2, fontWeight: 'bold' }}>
              {formData.isSetAside && (
                <div>
                  MATTER SET ASIDE{formData.setAsideDate ? ` on ${displayDate(formData.setAsideDate)}` : ''}
                  {formData.setAsideReason ? ` — ${formData.setAsideReason}` : ''}
                </div>
              )}
              {formData.isNotProceeding && (
                <div>
                  MATTER NOT PROCEEDING{formData.notProceedingDate ? ` (decided ${displayDate(formData.notProceedingDate)})` : ''}
                  {formData.notProceedingReason ? ` — ${formData.notProceedingReason}` : ''}
                </div>
              )}
            </Alert>
          )}

          {/* Matter Tabs */}
          <Paper sx={{ mb: 2, position: 'relative' }} ref={containerRef}>
            <Tabs
              value={value}
              onChange={(e, newIndex) => {
                setValue(newIndex);
              }}
              aria-label="Matter details tabs"
            >
              {visibleTabs.map((tab, index) => (
                <Tab
                  key={tab.label}
                  label={tab.label}
                  value={index}
                  onClick={tab.label === 'Assets' ? handleAssetsMenuClick : undefined}
                />
              ))}
            </Tabs>
          </Paper>

          {/* VALUE 0: ESTATE INFORMATION TAB */}
          {value === 0 && (
            <Box>
              {(() => {
                const estateClassification = formData.estateClassification;
                const isVoluntary = formData.isVoluntary === true || formData.isVoluntary === "1" || formData.isVoluntary === 1 || String(formData.isVoluntary) === "true";
                const isNPAClassification = estateClassification === 'NPA' || estateClassification === 'Npa Matters' || estateClassification === 'Curator Appointments';
                const isCompany = estateClassification === 'Company';
                const isCCBK = estateClassification === 'CC/BK';
                const isInsolvencyOrLiquidation = estateClassification === 'Company' || estateClassification === 'CC/BK' || estateClassification === 'Person';
                const isCm26liq = formData.cm26liqObtained === true || formData.cm26liqObtained === "1" || formData.cm26liqObtained === 1 || String(formData.cm26liqObtained) === "true";

                const ESTATE_CORE_FIELDS = [
                  { label: "Master Reference", name: "estateNo", sm: 4 },
                  ...(isNPAClassification ? [{ label: "Case Number", name: "caseNumber", sm: 4 }] : []),
                  { label: "Estate Name", name: "matterName", sm: 4 },
                  ...((!isVoluntary || isCm26liq) ? [
                    { 
                      label: isNPAClassification ? "High Court" : "Meeting Place", 
                      name: isNPAClassification ? "highCourtOffice" : "magistrateOffice",
                      sm: 4
                    },
                  ] : []),
                  {
                    label: "Masters Office",
                    name: "mastersOffice",
                    type: "select",
                    options: ['(Bhisho) Eastern Cape', '(Bloemfontein) Free State', '(Cape Town) Western Cape', '(Durban) KwaZulu-Natal', '(Gqeberha) Eastern Cape', '(Johannesburg) Gauteng', '(Kimberley) Northern Cape', '(Makhanda) Eastern Cape', '(Mbombela) Mpumalanga', '(Mmabatho) Northern Cape', '(Middelburg) Mpumalanga', '(Pietermaritzburg) KwaZulu-Natal', '(Polokwane) Limpopo', '(Pretoria) Gauteng', '(Thohoyandou) Limpopo', '(Umtata) Eastern Cape'],
                    sm: 4
                  },
                  ...(isNPAClassification ? [{ label: "Letter of Curatorship", name: "reductionAllowedDate", type: "date", sm: 4 }] : []),
                  ...(isNPAClassification ? [
                    { label: "Prov Preservation Order", name: "provisionalLiquidationDate", type: "date", sm: 4 },
                    { label: "Final Preservation Order", name: "finalLiquidationDate", type: "date", sm: 4 },
                    { label: "Prov Restraint Order", name: "provisionalAppointmentDate", type: "date", sm: 4 },
                    { label: "Final Restraint Order", name: "finalAppointmentDate", type: "date", sm: 4 },
                    { label: "Confiscation Order", name: "reductionRequestDate", type: "date", sm: 4 },
                    { label: "Forfeiture Order", name: "forfeitureOrderDate", type: "date", sm: 4 },
                    { label: "Realisation Order", name: "realisationOrderDate", type: "date", sm: 4 },
                    { label: "Release Date", name: "dischargeDate", type: "date", sm: 4 },
                  ] : [
                    ...(!isVoluntary && formData.hasProvisionalOrders !== false && (formData.provOrderObtained === true || formData.provOrderObtained === "1" || formData.provOrderObtained === 1 || String(formData.provOrderObtained) === "true") ? [
                      { label: "Provisional Court Order", name: "provisionalLiquidationDate", type: "date", sm: 4 }
                    ] : []),
                    ...(!isVoluntary && (formData.finalOrderObtained === true || formData.finalOrderObtained === "1" || formData.finalOrderObtained === 1 || String(formData.finalOrderObtained) === "true") ? [
                      { label: "Final Court Order", name: "finalLiquidationDate", type: "date", sm: 4 }
                    ] : []),
                    ...(isVoluntary && isCm26liq ? [
                      { label: "CM26LIQ Date", name: "cm26liqDate", type: "date", sm: 4 }
                    ] : []),
                    ...(!isCCBK && (formData.provisionalCertificate === true || formData.provisionalCertificate === "1" || formData.provisionalCertificate === 1 || String(formData.provisionalCertificate) === "true") ? [
                      { label: "Provisional Appointment Certificate", name: "provisionalAppointmentDate", type: "date", sm: 4 }
                    ] : []),
                    ...((formData.finalAppObtained === true || formData.finalAppObtained === "1" || formData.finalAppObtained === 1 || String(formData.finalAppObtained) === "true") ? [
                      { label: "Final Appointment Certificate", name: "finalAppointmentDate", type: "date", sm: 4 }
                    ] : []),
                    { label: "Release Date", name: "dischargeDate", type: "date", sm: 4 },
                  ]),
                ];

                const bondEntries = formData.bondEntries || [];
                const INSURER_OPTIONS = [
                  'Shackleton Risk Management (Pty) Ltd',
                  'Liquidation Bonding Services (Pty) Ltd',
                  'The Hollard Court Bonds (Pty) Ltd'
                ];

                const handleAddBondEntry = () => {
                  let previousInfo = { insurerName: '', policyNumber: '', inceptionDate: '', policyRenewalDate: '', insuredAmount: '' };
                  if (bondEntries.length > 0) {
                    const lastEntry = bondEntries[bondEntries.length - 1];
                    let newInceptionDate = lastEntry.policyRenewalDate || '';
                    let newPolicyRenewalDate = '';
                    if (newInceptionDate) {
                      const d = new Date(newInceptionDate);
                      if (!isNaN(d.getTime())) {
                        d.setFullYear(d.getFullYear() + 1);
                        newPolicyRenewalDate = d.toISOString().split('T')[0];
                      }
                    }
                    // "Reduction/Increase Amount" is a delta on top of the insured amount, not a
                    // standalone replacement figure — carry forward the combined running total.
                    const combinedLastAmount = parseMoney(lastEntry.insuredAmount) + parseMoney(lastEntry.finalInsuredAmount);
                    const lastBondAmount = combinedLastAmount || '';

                    previousInfo = {
                      insurerName: lastEntry.insurerName || '',
                      policyNumber: lastEntry.policyNumber || '',
                      inceptionDate: newInceptionDate,
                      policyRenewalDate: newPolicyRenewalDate,
                      insuredAmount: lastBondAmount
                    };
                  }
                  setBondForm({
                    id: Date.now(),
                    ...previousInfo,
                    reductionIncreaseDate: '',
                    finalInsuredAmount: '',
                    isPaid: false
                  });
                  setEditingBondId('NEW');
                };

                const handleEditBondEntry = (entry) => {
                  setBondForm({ ...entry });
                  setEditingBondId(entry.id);
                };

                const handleRemoveBondEntry = (id, e) => {
                  if (e) e.stopPropagation();
                  if (!window.confirm('Are you sure you want to delete this bond entry?')) return;
                  const newEntries = bondEntries.filter(entry => entry.id !== id);
                  handleFieldChange({ target: { name: 'bondEntries', value: newEntries, type: 'array' } });
                  if (editingBondId === id) {
                    setEditingBondId(null);
                    setBondForm(null);
                  }
                };

                const handleSaveBondForm = () => {
                  // Normalise money fields to a plain numeric string so mixed-locale input
                  // ("1.964.495,30", "1 964 495,30", …) is stored consistently.
                  const normalisedForm = {
                    ...bondForm,
                    insuredAmount: bondForm.insuredAmount === '' || bondForm.insuredAmount === undefined || bondForm.insuredAmount === null
                      ? '' : String(parseMoney(bondForm.insuredAmount)),
                    finalInsuredAmount: bondForm.finalInsuredAmount === '' || bondForm.finalInsuredAmount === undefined || bondForm.finalInsuredAmount === null
                      ? '' : String(parseMoney(bondForm.finalInsuredAmount)),
                  };
                  let newEntries = [...bondEntries];
                  if (editingBondId === 'NEW') {
                    newEntries.push(normalisedForm);
                  } else {
                    newEntries = newEntries.map(e => e.id === editingBondId ? normalisedForm : e);
                  }
                  handleFieldChange({ target: { name: 'bondEntries', value: newEntries, type: 'array' } });
                  setEditingBondId(null);
                  setBondForm(null);
                };

                const handleCancelBondForm = () => {
                  setEditingBondId(null);
                  setBondForm(null);
                };

                const isFirstBondEntry = editingBondId === 'NEW' ? bondEntries.length === 0 : bondEntries[0]?.id === editingBondId;

                const handleBondFormChange = (e) => {
                  const { name, value, type, checked } = e.target;
                  const finalValue = type === 'checkbox' ? checked : value;
                  setBondForm(prev => {
                    const updated = { ...prev, [name]: finalValue };
                    if (name === 'inceptionDate' && finalValue) {
                      const date = new Date(finalValue);
                      if (!isNaN(date.getTime())) {
                        date.setFullYear(date.getFullYear() + 1);
                        updated.policyRenewalDate = date.toISOString().split('T')[0];
                      }
                    }
                    if (name === 'reductionIncreaseDate' && finalValue) {
                      const date = new Date(finalValue);
                      if (!isNaN(date.getTime())) {
                        date.setFullYear(date.getFullYear() + 1);
                        updated.policyRenewalDate = date.toISOString().split('T')[0];
                      }
                    }
                    return updated;
                  });
                };

                const respondents = Array.isArray(formData.respondents) ? formData.respondents : [];

                // Distinguish "1st Respondent" from "2nd Defendant" etc. (ordinal counted
                // separately per type) so order-linking dropdowns show who's who.
                const getOrdinalWord = (n) => {
                  if (n % 10 === 1 && n % 100 !== 11) return `${n}st`;
                  if (n % 10 === 2 && n % 100 !== 12) return `${n}nd`;
                  if (n % 10 === 3 && n % 100 !== 13) return `${n}rd`;
                  return `${n}th`;
                };
                const respondentsWithRole = respondents.map((r) => {
                  const type = r.type || 'Respondent';
                  const sameTypeEntries = respondents.filter(x => (x.type || 'Respondent') === type);
                  const ordinal = sameTypeEntries.findIndex(x => String(x.id) === String(r.id)) + 1;
                  return { ...r, roleLabel: `${getOrdinalWord(ordinal)} ${type}` };
                });

                return (
                  <React.Fragment>
                    {/* MAIN ESTATE INFORMATION BOX */}
                    <Box sx={containerStyle}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                        <Typography variant="h6">
                          Estate Information
                        </Typography>
                      </Stack>

                      <Grid container spacing={2}>
                        {ESTATE_CORE_FIELDS.map(({ label, name, type, options, sm }) => (
                          <Grid item xs={12} sm={sm} key={name}>
                            {type === "autocomplete" ? (
                              <Autocomplete
                                fullWidth
                                freeSolo
                                options={options || []}
                                getOptionLabel={(option) => typeof option === 'string' ? option : (option.label || "")}
                                isOptionEqualToValue={(option, value) => {
                                  const optValue = typeof option === 'string' ? option : option.label;
                                  const valValue = typeof value === 'string' ? value : value?.label;
                                  return optValue === valValue;
                                }}
                                autoHighlight
                                openOnFocus
                                disabled={!isEditingMode || user?.role === 'guest'}
                                value={
                                  options && options.length > 0 && typeof options[0] === 'object'
                                  ? options.find(opt => opt.label === formData[name]) || formData[name] || ""
                                  : formData[name] || ""
                                }
                                onChange={(event, newValue) => {
                                  handleFieldChange({
                                    target: {
                                      name: name,
                                      value: typeof newValue === 'object' && newValue !== null ? newValue.label : (newValue || "")
                                    }
                                  });
                                }}
                                onInputChange={(event, newInputValue) => {
                                  handleFieldChange({
                                    target: {
                                      name: name,
                                      value: newInputValue || ""
                                    }
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={label}
                                    variant="outlined"
                                    placeholder="Start typing to search or add new..."
                                    InputLabelProps={{ shrink: true }}
                                  />
                                )}
                              />
                            ) : type === "select-boolean" ? (
                              <TextField 
                                select 
                                fullWidth 
                                label={label} 
                                name={name} 
                                value={formData[name] === true ? 'true' : 'false'} 
                                onChange={(e) => handleFieldChange({ target: { name, value: e.target.value === 'true', type: 'checkbox' }})} 
                                variant="outlined" 
                                disabled={!isEditingMode || user?.role === 'guest'}
                              >
                                {(options || []).map(option => (
                                  <MenuItem key={option.label} value={option.value === true ? 'true' : 'false'}>{option.label}</MenuItem>
                                ))}
                              </TextField>
                            ) : type === "select" ? (
                              <TextField 
                                select 
                                fullWidth 
                                label={label} 
                                name={name} 
                                value={formData[name] || ''} 
                                onChange={handleFieldChange} 
                                variant="outlined" 
                                disabled={!isEditingMode || user?.role === 'guest'}
                              >
                                {(options || []).map(option => (
                                  <MenuItem key={option} value={option}>{option}</MenuItem>
                                ))}
                              </TextField>
                            ) : type === "date" ? (
                              <TextField 
                                fullWidth 
                                label={label} 
                                name={name} 
                                type="date" 
                                value={formData[name] || ''} 
                                onChange={handleFieldChange} 
                                variant="outlined" 
                                disabled={!isEditingMode || user?.role === 'guest'} 
                                InputLabelProps={{ shrink: true }} 
                                inputProps={{ max: '9999-12-31' }} 
                              />
                            ) : (
                              <TextField 
                                fullWidth 
                                label={label} 
                                name={name} 
                                value={formData[name] || ''} 
                                onChange={handleFieldChange} 
                                variant="outlined" 
                                multiline 
                                minRows={1} 
                                maxRows={4} 
                                disabled={!isEditingMode || user?.role === 'guest'} 
                                InputLabelProps={{ shrink: !!formData[name] }} 
                              />
                            )}
                          </Grid>
                        ))}

                        {/* NPA: Anticipation Order */}
                        {isNPAClassification && (
                          <>
                            <Grid item xs={12} sm={4}>
                              <TextField
                                fullWidth
                                label="Anticipation Order"
                                name="anticipationOrderDate"
                                type="date"
                                value={formData.anticipationOrderDate || ''}
                                onChange={handleFieldChange}
                                variant="outlined"
                                disabled={!isEditingMode || user?.role === 'guest'}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ max: '9999-12-31' }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={8}>
                              <Autocomplete
                                multiple
                                fullWidth
                                options={respondentsWithRole}
                                getOptionLabel={(option) => `${option.roleLabel} - ${option.name || 'Unnamed'}`}
                                isOptionEqualToValue={(option, value) => String(option.id) === String(value.id)}
                                value={respondentsWithRole.filter(r => (formData.anticipationOrderRespondentIds || []).map(String).includes(String(r.id)))}
                                onChange={(event, newValue) => {
                                  handleFieldChange({
                                    target: {
                                      name: 'anticipationOrderRespondentIds',
                                      value: newValue.map(v => v.id),
                                      type: 'array'
                                    }
                                  });
                                }}
                                disabled={!isEditingMode || user?.role === 'guest'}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Respondent(s) / Defendant(s)"
                                    variant="outlined"
                                    placeholder={respondents.length ? "Select name(s)" : "Add a respondent below first"}
                                  />
                                )}
                              />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                              <Autocomplete
                                multiple
                                fullWidth
                                options={respondentsWithRole}
                                getOptionLabel={(option) => `${option.roleLabel} - ${option.name || 'Unnamed'}`}
                                isOptionEqualToValue={(option, value) => String(option.id) === String(value.id)}
                                value={respondentsWithRole.filter(r => (formData.confiscationOrderRespondentIds || []).map(String).includes(String(r.id)))}
                                onChange={(event, newValue) => {
                                  handleFieldChange({
                                    target: {
                                      name: 'confiscationOrderRespondentIds',
                                      value: newValue.map(v => v.id),
                                      type: 'array'
                                    }
                                  });
                                }}
                                disabled={!isEditingMode || user?.role === 'guest'}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Respondent(s) Confiscation Order was made against"
                                    variant="outlined"
                                    placeholder={respondents.length ? "Select name(s)" : "Add a respondent below first"}
                                  />
                                )}
                              />
                            </Grid>
                          </>
                        )}

                        {/* Classification Specific Data */}
                        {(isCompany || isCCBK || estateClassification === 'Administration of Estates') && (
                          <React.Fragment>
                            <Grid item xs={12} sm={3}>
                              <TextField fullWidth label="Registration No." name="registrationNo" value={formData.registrationNo || ''} onChange={handleFieldChange} variant="outlined" disabled={!isEditingMode || user?.role === 'guest'} size="small" InputLabelProps={{ shrink: !!formData.registrationNo }} />
                            </Grid>
                            <Grid item xs={12} sm={2} sx={{ display: 'flex', alignItems: 'center' }}>
                              <FormControlLabel control={<Checkbox name="hasIncomeTax" checked={formData.hasIncomeTax === true || formData.hasIncomeTax === "1" || formData.hasIncomeTax === 1 || String(formData.hasIncomeTax) === "true"} onChange={handleFieldChange} disabled={!isEditingMode || user?.role === 'guest'} />} label={<Typography variant="body2">Income Tax</Typography>} />
                            </Grid>
                            {(formData.hasIncomeTax === true || formData.hasIncomeTax === "1" || formData.hasIncomeTax === 1 || String(formData.hasIncomeTax) === "true") && (
                              <Grid item xs={12} sm={3}>
                                <TextField fullWidth label="Tax No." name="taxNo" value={formData.taxNo || ''} onChange={handleFieldChange} variant="outlined" disabled={!isEditingMode || user?.role === 'guest'} size="small" InputLabelProps={{ shrink: !!formData.taxNo }} />
                              </Grid>
                            )}
                            {(isCompany || estateClassification === 'Administration of Estates' || isVoluntary) && (
                              <>
                                <Grid item xs={12} sm={1} sx={{ display: 'flex', alignItems: 'center' }}>
                                  <FormControlLabel control={<Checkbox name="hasVat" checked={formData.hasVat === true || formData.hasVat === "1" || formData.hasVat === 1 || String(formData.hasVat) === "true"} onChange={handleFieldChange} disabled={!isEditingMode || user?.role === 'guest'} />} label={<Typography variant="body2">VAT</Typography>} />
                                </Grid>
                                {(formData.hasVat === true || formData.hasVat === "1" || formData.hasVat === 1 || String(formData.hasVat) === "true") && (
                                  <Grid item xs={12} sm={3}>
                                    <TextField fullWidth label="VAT No." name="vatNo" value={formData.vatNo || ''} onChange={handleFieldChange} variant="outlined" disabled={!isEditingMode || user?.role === 'guest'} size="small" InputLabelProps={{ shrink: !!formData.vatNo }} />
                                  </Grid>
                                )}
                              </>
                            )}
                          </React.Fragment>
                        )}

                        {/* Document / Order Checkboxes */}
                        {!isNPAClassification && [
                          ...(!isVoluntary ? [
                            { label: "Court Application", name: "courtAppObtained" },
                            ...(formData.hasProvisionalOrders !== false ? [{ label: "Provisional Court Order", name: "provOrderObtained" }] : []),
                            { label: "Final Court Order", name: "finalOrderObtained" },
                            ...(!isCCBK ? [{ label: "Provisional Appointment Certificate", name: "provisionalCertificate" }] : []),
                            { label: "Final Appointment Certificate", name: "finalAppObtained" }
                          ] : [
                            { label: "CM26LIQ", name: "cm26liqObtained" },
                            { label: "CM100", name: "cm100Obtained" },
                            ...(!isCCBK ? [{ label: "Provisional Appointment Certificate", name: "provisionalCertificate" }] : []),
                            { label: "Final Appointment Certificate", name: "finalAppObtained" }
                          ])
                        ].map(({ label, name }) => (
                          <Grid item xs={12} sm={3} key={name}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name={name}
                                  checked={formData[name] === true || formData[name] === "1" || formData[name] === 1 || String(formData[name]) === "true"}
                                  onChange={handleFieldChange}
                                  color="primary"
                                  disabled={!isEditingMode || user?.role === 'guest'}
                                />
                              }
                              label={label}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </Box>

                    {/* DIRECTORS / MEMBERS TABLE */}
                    {(formData.estateClassification === 'Company' || formData.estateClassification === 'CC/BK') && (
                      <Box sx={{ ...containerStyle, marginTop: 4 }}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                            Member(s) / Director(s)
                          </Typography>
                          <Button 
                            variant="contained" 
                            startIcon={<AddCircleOutlineIcon />}
                            disabled={!isEditingMode || user?.role === 'guest'}
                            onClick={() => handleOpenDirMemForm()}
                          >
                            Add Member / Director
                          </Button>
                        </Stack>

                        <TableContainer component={Paper} variant="outlined">
                          <Table size="small">
                            <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                              <TableRow>
                                <TableCell sx={{ fontWeight: 'bold', width: '5%' }}>#</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '20%' }}>Full Name & Surname</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '15%' }}>ID Number</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '10%' }}>Living Status</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '20%' }}>Contact Details</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '25%' }}>Physical Address</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '5%' }}>Actions</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {(Array.isArray(formData.stakeholders) ? formData.stakeholders : []).map((row, index) => (
                                <TableRow key={row.id || index} hover>
                                  <TableCell>{index + 1}</TableCell>
                                  <TableCell>{row.fullName || '-'}</TableCell>
                                  <TableCell>{row.idNumber || '-'}</TableCell>
                                  <TableCell>{row.status || '-'}</TableCell>
                                  <TableCell>
                                    {row.phone && <Typography variant="body2">{row.phone}</Typography>}
                                    {row.email ? (
                                      <Stack direction="row" alignItems="center" spacing={1}>
                                        <Box>
                                          {row.email.split(/[,;]+/).map((e, idx) => (
                                            <Typography key={idx} variant="body2" color="textSecondary">{e.trim()}</Typography>
                                          ))}
                                        </Box>
                                        <IconButton size="small" color="primary" onClick={() => window.location.href = `mailto:${row.email.replace(/;/g, ',')}`}>
                                          <MailOutlineIcon fontSize="small" />
                                        </IconButton>
                                      </Stack>
                                    ) : null}
                                  </TableCell>
                                  <TableCell>{row.address || '-'}</TableCell>
                                  <TableCell>
                                    <Stack direction="row" spacing={1}>
                                      <IconButton color="primary" size="small" disabled={!isEditingMode || user?.role === 'guest'} onClick={() => handleOpenDirMemForm(index)}>
                                        <EditIcon fontSize="small" />
                                      </IconButton>
                                      <IconButton color="error" size="small" disabled={!isEditingMode || user?.role === 'guest'} onClick={() => {
                                        if(window.confirm('Are you sure you want to delete this entry?')) {
                                          const filtered = formData.stakeholders.filter((_, i) => i !== index);
                                          handleFieldChange({ target: { name: 'stakeholders', value: filtered, type: 'array' } });
                                        }
                                      }}>
                                        <DeleteIcon fontSize="small" />
                                      </IconButton>
                                    </Stack>
                                  </TableCell>
                                </TableRow>
                              ))}
                              {(!formData.stakeholders || formData.stakeholders.length === 0) && (
                                <TableRow>
                                  <TableCell colSpan={7} align="center" sx={{ py: 3, color: 'text.secondary', fontStyle: 'italic' }}>
                                    No entries added. Click the add button to begin.
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>

                        {/* Dialog for Add/Edit Director/Member */}
                        <Dialog open={dirMemFormOpen} onClose={handleCloseDirMemForm} fullWidth maxWidth="sm">
                          <DialogTitle>{editingDirMemIndex !== null ? 'Edit ' : 'Add '} Member / Director</DialogTitle>
                          <DialogContent dividers>
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={6}>
                                <TextField fullWidth size="small" label="Full Name & Surname" value={dirMemForm.fullName || ''} onChange={(e) => setDirMemForm({ ...dirMemForm, fullName: e.target.value })} sx={{ mt: 1 }} />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField fullWidth size="small" label="ID Number" value={dirMemForm.idNumber || ''} onChange={(e) => setDirMemForm({ ...dirMemForm, idNumber: e.target.value })} sx={{ mt: 1 }} />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField select fullWidth size="small" label="Living Status" value={dirMemForm.status || 'Alive'} onChange={(e) => setDirMemForm({ ...dirMemForm, status: e.target.value })}>
                                  <MenuItem value="Alive">Alive</MenuItem>
                                  <MenuItem value="Deceased">Deceased</MenuItem>
                                </TextField>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField fullWidth size="small" label="Phone Number" value={dirMemForm.phone || ''} onChange={(e) => setDirMemForm({ ...dirMemForm, phone: e.target.value })} />
                              </Grid>
                              <Grid item xs={12} sm={12}>
                                <TextField fullWidth size="small" label="Email Address(es)" value={dirMemForm.email || ''} onChange={(e) => setDirMemForm({ ...dirMemForm, email: e.target.value })} helperText="Separate multiple emails with commas" />
                              </Grid>
                              <Grid item xs={12}>
                                <TextField fullWidth size="small" multiline rows={2} label="Physical Address" value={dirMemForm.address || ''} onChange={(e) => setDirMemForm({ ...dirMemForm, address: e.target.value })} />
                              </Grid>
                            </Grid>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={handleCloseDirMemForm}>Cancel</Button>
                            <Button onClick={handleSaveDirMem} variant="contained" color="primary">Save</Button>
                          </DialogActions>
                        </Dialog>
                      </Box>
                    )}

                    {/* INSOLVENT INDIVIDUALS TABLE */}
                    {formData.estateClassification === 'Person' && (
                      <Box sx={{ ...containerStyle, marginTop: 4 }}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                          <Typography variant="h6">Insolvents Information</Typography>
                          <Button 
                            variant="contained" 
                            startIcon={<AddCircleOutlineIcon />}
                            disabled={!isEditingMode || user?.role === 'guest'}
                            onClick={() => handleOpenInsolventForm()}
                          >
                            Add Insolvent
                          </Button>
                        </Stack>

                        <TableContainer component={Paper} variant="outlined">
                          <Table size="small">
                            <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                              <TableRow>
                                <TableCell sx={{ fontWeight: 'bold' }}>#</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Full Name & Surname</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>ID Number</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Marital Status</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Contact Details</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Income Tax No.</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>VAT No.</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {(Array.isArray(formData.stakeholders) ? formData.stakeholders : []).map((row, index) => (
                                <TableRow key={row.id || index} hover>
                                  <TableCell>{index + 1}</TableCell>
                                  <TableCell>{row.fullName || '-'}</TableCell>
                                  <TableCell>{row.idNumber || '-'}</TableCell>
                                  <TableCell>{row.status || '-'}</TableCell>
                                  <TableCell>{row.maritalStatus || '-'}</TableCell>
                                  <TableCell>
                                    {row.phone && <Typography variant="body2">{row.phone}</Typography>}
                                    {row.email ? (
                                      <Stack direction="row" alignItems="center" spacing={1}>
                                        <Box>
                                          {row.email.split(/[,;]+/).map((e, idx) => (
                                            <Typography key={idx} variant="body2" color="textSecondary">{e.trim()}</Typography>
                                          ))}
                                        </Box>
                                        <IconButton size="small" color="primary" onClick={() => window.location.href = `mailto:${row.email.replace(/;/g, ',')}`}>
                                          <MailOutlineIcon fontSize="small" />
                                        </IconButton>
                                      </Stack>
                                    ) : null}
                                    {row.address && <Typography variant="caption" color="textSecondary" display="block">{row.address}</Typography>}
                                  </TableCell>
                                  <TableCell>{row.taxNo || '-'}</TableCell>
                                  <TableCell>{row.vatNo || '-'}</TableCell>
                                  <TableCell>
                                    <Stack direction="row" spacing={1}>
                                      <IconButton
                                        color="primary"
                                        size="small"
                                        disabled={!isEditingMode || user?.role === 'guest'}
                                        onClick={() => handleOpenInsolventForm(index)}
                                      >
                                        <EditIcon fontSize="small" />
                                      </IconButton>
                                      <IconButton 
                                        color="error" 
                                        size="small" 
                                        disabled={!isEditingMode || user?.role === 'guest'}
                                        onClick={() => {
                                          if(window.confirm('Are you sure you want to delete this insolvent?')) {
                                            const filtered = formData.stakeholders.filter((_, i) => i !== index);
                                            handleFieldChange({ target: { name: 'stakeholders', value: filtered, type: 'array' } });
                                          }
                                        }}
                                      >
                                        <DeleteIcon fontSize="small" />
                                      </IconButton>
                                    </Stack>
                                  </TableCell>
                                </TableRow>
                              ))}
                              {(!formData.stakeholders || formData.stakeholders.length === 0) && (
                                <TableRow>
                                  <TableCell colSpan={9} align="center" sx={{ py: 3, color: 'text.secondary', fontStyle: 'italic' }}>
                                    No insolvents added. Click "Add Insolvent" to begin.
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>

                        {/* Dialog for Add/Edit Insolvent */}
                        <Dialog open={insolventFormOpen} onClose={handleCloseInsolventForm} fullWidth maxWidth="sm">
                          <DialogTitle>{editingInsolventIndex !== null ? 'Edit Insolvent' : 'Add Insolvent'}</DialogTitle>
                          <DialogContent dividers>
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={6}>
                                <TextField fullWidth size="small" label="Full Name & Surname" value={insolventForm.fullName || ''} onChange={(e) => setInsolventForm({ ...insolventForm, fullName: e.target.value })} sx={{ mt: 1 }} />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField fullWidth size="small" label="ID Number" value={insolventForm.idNumber || ''} onChange={(e) => setInsolventForm({ ...insolventForm, idNumber: e.target.value })} sx={{ mt: 1 }} />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField select fullWidth size="small" label="Status" value={insolventForm.status || 'Alive'} onChange={(e) => setInsolventForm({ ...insolventForm, status: e.target.value })}>
                                  <MenuItem value="Alive">Alive</MenuItem>
                                  <MenuItem value="Deceased">Deceased</MenuItem>
                                </TextField>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField select fullWidth size="small" label="Marital Status" value={insolventForm.maritalStatus || 'Single'} onChange={(e) => setInsolventForm({ ...insolventForm, maritalStatus: e.target.value })}>
                                  <MenuItem value="Single">Single</MenuItem>
                                  <MenuItem value="Married">Married</MenuItem>
                                  <MenuItem value="Married In Community">Married In Community</MenuItem>
                                  <MenuItem value="Married ANC">Married ANC</MenuItem>
                                  <MenuItem value="Divorced">Divorced</MenuItem>
                                  <MenuItem value="Widowed">Widowed</MenuItem>
                                </TextField>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField fullWidth size="small" label="Cell Number" value={insolventForm.phone || ''} onChange={(e) => setInsolventForm({ ...insolventForm, phone: e.target.value })} />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField fullWidth size="small" label="Email Address(es)" value={insolventForm.email || ''} onChange={(e) => setInsolventForm({ ...insolventForm, email: e.target.value })} helperText="Separate multiple emails with commas" />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField fullWidth size="small" label="Income Tax No." value={insolventForm.taxNo || ''} onChange={(e) => setInsolventForm({ ...insolventForm, taxNo: e.target.value })} />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField fullWidth size="small" label="VAT Registration No." value={insolventForm.vatNo || ''} onChange={(e) => setInsolventForm({ ...insolventForm, vatNo: e.target.value })} helperText="Optional - only if the insolvent is VAT registered" />
                              </Grid>
                              <Grid item xs={12}>
                                <TextField fullWidth size="small" multiline rows={2} label="Home Address" value={insolventForm.address || ''} onChange={(e) => setInsolventForm({ ...insolventForm, address: e.target.value })} />
                              </Grid>
                            </Grid>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={handleCloseInsolventForm}>Cancel</Button>
                            <Button onClick={handleSaveInsolvent} variant="contained" color="primary">Save</Button>
                          </DialogActions>
                        </Dialog>
                      </Box>
                    )}

                    {/* NPA: ORDER DOCUMENTS - link a document to each order */}
                    {isNPAClassification && (
                      <Box sx={{ ...containerStyle, marginTop: 4 }}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mb: 2 }}>
                          Documents
                        </Typography>
                        <Grid container spacing={2} sx={{ mb: 3 }}>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              fullWidth
                              label="Letter of Curatorship No."
                              name="letterOfCuratorshipNumber"
                              value={formData.letterOfCuratorshipNumber || ''}
                              onChange={handleFieldChange}
                              disabled={!isEditingMode || user?.role === 'guest'}
                              helperText="Feeds the Curator's Report - 'Letter of Curatorship No. ___'"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              fullWidth
                              type="date"
                              label="Letter of Curatorship Date Issued"
                              name="letterOfCuratorshipDate"
                              value={formData.letterOfCuratorshipDate || ''}
                              onChange={handleFieldChange}
                              disabled={!isEditingMode || user?.role === 'guest'}
                              InputLabelProps={{ shrink: true }}
                              inputProps={{ max: '9999-12-31' }}
                              helperText="Feeds the Curator's Report - date issued / date of appointment"
                            />
                          </Grid>
                        </Grid>
                        <TableContainer component={Paper} variant="outlined">
                          <Table size="small">
                            <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                              <TableRow>
                                <TableCell sx={{ fontWeight: 'bold' }}>Documents</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Linked Document</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '1%' }}>Actions</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {ORDER_DOCUMENT_FIELDS.map(({ label, field }) => {
                                const docUrl = formData[field];
                                const docName = docUrl ? docUrl.split('/').pop() : null;
                                return (
                                  <TableRow key={field}>
                                    <TableCell>{label}</TableCell>
                                    <TableCell>
                                      {docName ? (
                                        <Typography variant="body2" noWrap>{docName}</Typography>
                                      ) : (
                                        <Typography variant="body2" color="text.secondary" fontStyle="italic">No document linked</Typography>
                                      )}
                                    </TableCell>
                                    <TableCell align="center">
                                      <Stack direction="row" spacing={1} justifyContent="center">
                                        <Button
                                          size="small"
                                          variant="outlined"
                                          startIcon={docUrl ? <VisibilityIcon /> : <AttachFileIcon />}
                                          color={docUrl ? 'success' : 'primary'}
                                          disabled={!isEditingMode || user?.role === 'guest'}
                                          onClick={() => handleOpenOrderDocPicker(field)}
                                        >
                                          {docUrl ? 'View / Change' : 'Attach'}
                                        </Button>
                                      </Stack>
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        {orderDocPickerOpen && (
                          <DocumentPreviewer
                            open={orderDocPickerOpen}
                            onClose={() => setOrderDocPickerOpen(false)}
                            matterId={id}
                            user={user}
                            folder="Order Documents"
                            activeDocPath={activeOrderDocField ? formData[activeOrderDocField] : null}
                            onDocumentSelect={(filepath) => {
                              saveOrderDocField(activeOrderDocField, filepath);
                              setOrderDocPickerOpen(false);
                            }}
                            onDocumentDelete={() => {
                              saveOrderDocField(activeOrderDocField, '');
                            }}
                          />
                        )}
                      </Box>
                    )}

                    {/* DEFENDANTS / RESPONDENTS TABLE */}
                    {isNPAClassification && (
                      <Box sx={{ ...containerStyle, marginTop: 4 }}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                            Defendants / Respondents Information
                          </Typography>
                          <Stack direction="row" spacing={1}>
                            <Button
                              variant="contained"
                              startIcon={<AddCircleOutlineIcon />}
                              disabled={!isEditingMode || user?.role === 'guest'}
                              onClick={() => handleOpenRespondentForm(null, 'Defendant')}
                            >
                              Add Defendant
                            </Button>
                            <Button
                              variant="contained"
                              startIcon={<AddCircleOutlineIcon />}
                              disabled={!isEditingMode || user?.role === 'guest'}
                              onClick={() => handleOpenRespondentForm(null, 'Respondent')}
                            >
                              Add Respondent
                            </Button>
                          </Stack>
                        </Stack>

                        <TableContainer component={Paper} variant="outlined">
                          <Table size="small">
                            <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                              <TableRow>
                                <TableCell sx={{ fontWeight: 'bold', width: '15%' }}>Party</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '20%' }}>Name</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '15%' }}>ID / Reg No</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '15%' }}>Contact Details</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '15%' }}>Email Address</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '15%' }}>Marital Status</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '5%' }}>Actions</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {/* Court-order style: 1st/2nd/3rd Defendant first, then 1st/2nd/3rd Respondent. */}
                              {[...respondentsWithRole].sort((a, b) => ((a.type === 'Defendant' ? 0 : 1) - (b.type === 'Defendant' ? 0 : 1))).map((resp, index) => (
                                <TableRow key={resp.id || `resp-${index}`}>
                                  <TableCell sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>{resp.roleLabel}</TableCell>
                                  <TableCell>
                                    {resp.name || '-'}
                                    {resp.entityType && resp.entityType !== 'Individual' && (
                                      <Typography variant="caption" display="block" color="text.secondary">{resp.entityType === 'CC' ? 'Close Corporation (CC)' : resp.entityType}</Typography>
                                    )}
                                  </TableCell>
                                  <TableCell>{resp.idNo || '-'}</TableCell>
                                  <TableCell>{resp.contactDetails || '-'}</TableCell>
                                  <TableCell>
                                    {resp.emailAddress ? (
                                      <Stack direction="row" alignItems="center" spacing={1}>
                                        <Box>
                                          {resp.emailAddress.split(/[,;]+/).map((e, idx) => (
                                            <Typography key={idx} variant="body2">{e.trim()}</Typography>
                                          ))}
                                        </Box>
                                        <IconButton size="small" color="primary" onClick={() => window.location.href = `mailto:${resp.emailAddress.replace(/;/g, ',')}`}>
                                          <MailOutlineIcon fontSize="small" />
                                        </IconButton>
                                      </Stack>
                                    ) : '-'}
                                  </TableCell>
                                  <TableCell>{resp.entityType && resp.entityType !== 'Individual' ? 'N/A' : (resp.maritalStatus || '-')}</TableCell>
                                  <TableCell>
                                    <Stack direction="row" spacing={1}>
                                      <IconButton color="primary" size="small" disabled={!isEditingMode || user?.role === 'guest'} onClick={() => handleOpenRespondentForm(respondents.find(r => String(r.id) === String(resp.id)) || resp)}>
                                        <EditIcon fontSize="small" />
                                      </IconButton>
                                      <IconButton color="error" size="small" disabled={!isEditingMode || user?.role === 'guest'} onClick={() => handleDeleteRespondent(resp.id)}>
                                        <DeleteIcon fontSize="small" />
                                      </IconButton>
                                    </Stack>
                                  </TableCell>
                                </TableRow>
                              ))}
                              {respondents.length === 0 && <TableRow><TableCell colSpan={7} align="center" sx={{ py: 3, color: 'text.secondary', fontStyle: 'italic' }}>No defendants or respondents added. Click "Add Defendant" or "Add Respondent" to begin.</TableCell></TableRow>}
                            </TableBody>
                          </Table>
                        </TableContainer>

                        {/* Dialog for Add/Edit Respondent */}
                        <Dialog open={respondentFormOpen} onClose={handleCloseRespondentForm} fullWidth maxWidth="sm">
                          <DialogTitle>
                            {(() => {
                              const formType = respondentForm.type || 'Respondent';
                              if (editingRespondentId) {
                                const existing = respondentsWithRole.find(r => String(r.id) === String(editingRespondentId));
                                return `Edit ${existing ? existing.roleLabel : formType}`;
                              }
                              const nextOrdinal = respondents.filter(r => (r.type || 'Respondent') === formType).length + 1;
                              return `Add ${getOrdinalWord(nextOrdinal)} ${formType}`;
                            })()}
                          </DialogTitle>
                          <DialogContent dividers>
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={6}>
                                <TextField
                                  select fullWidth size="small" label="Respondent or Defendant"
                                  value={respondentForm.type || 'Respondent'}
                                  onChange={(e) => setRespondentForm({ ...respondentForm, type: e.target.value })}
                                  sx={{ mt: 1 }}
                                  helperText={(() => {
                                    // Say exactly which party this will be, e.g. "1st Defendant" vs "1st Respondent".
                                    const formType = respondentForm.type || 'Respondent';
                                    const existing = editingRespondentId ? respondentsWithRole.find(r => String(r.id) === String(editingRespondentId)) : null;
                                    if (existing && (existing.type || 'Respondent') === formType) return `This is the ${existing.roleLabel}`;
                                    const nextOrdinal = respondents.filter(r => (r.type || 'Respondent') === formType && String(r.id) !== String(editingRespondentId)).length + 1;
                                    return `This will be the ${getOrdinalWord(nextOrdinal)} ${formType}`;
                                  })()}
                                >
                                  <MenuItem value="Defendant">Defendant</MenuItem>
                                  <MenuItem value="Respondent">Respondent</MenuItem>
                                </TextField>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField
                                  select fullWidth size="small" label="Individual or Company / CC"
                                  value={respondentForm.entityType || 'Individual'}
                                  onChange={(e) => setRespondentForm({
                                    ...respondentForm,
                                    entityType: e.target.value,
                                    // A company / CC / trust has no marital status.
                                    maritalStatus: e.target.value === 'Individual' ? (respondentForm.maritalStatus || 'Single') : '',
                                  })}
                                  sx={{ mt: 1 }}
                                >
                                  <MenuItem value="Individual">Individual</MenuItem>
                                  <MenuItem value="Company">Company (Pty) Ltd</MenuItem>
                                  <MenuItem value="CC">Close Corporation (CC)</MenuItem>
                                  <MenuItem value="Trust">Trust</MenuItem>
                                </TextField>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField fullWidth size="small" label={(respondentForm.entityType || 'Individual') === 'Individual' ? 'Name & Surname' : 'Company / CC / Trust Name'} value={respondentForm.name || ''} onChange={(e) => setRespondentForm({ ...respondentForm, name: e.target.value })} sx={{ mt: 1 }} />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField fullWidth size="small" label={(respondentForm.entityType || 'Individual') === 'Individual' ? 'ID No' : 'Registration No'} value={respondentForm.idNo || ''} onChange={(e) => setRespondentForm({ ...respondentForm, idNo: e.target.value })} sx={{ mt: 1 }} />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField fullWidth size="small" label="Contact Details" value={respondentForm.contactDetails || ''} onChange={(e) => setRespondentForm({ ...respondentForm, contactDetails: e.target.value })} />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <TextField fullWidth size="small" label="Email Address(es)" value={respondentForm.emailAddress || ''} onChange={(e) => setRespondentForm({ ...respondentForm, emailAddress: e.target.value })} helperText="Separate multiple emails with commas" />
                              </Grid>
                              {(respondentForm.entityType || 'Individual') === 'Individual' && (
                                <Grid item xs={12} sm={6}>
                                  <TextField select fullWidth size="small" label="Marital Status" value={respondentForm.maritalStatus || 'Single'} onChange={(e) => setRespondentForm({ ...respondentForm, maritalStatus: e.target.value })}>
                                    <MenuItem value="Single">Single</MenuItem>
                                    <MenuItem value="Married">Married</MenuItem>
                                    <MenuItem value="Married In Community">Married In Community</MenuItem>
                                    <MenuItem value="Married ANC">Married ANC</MenuItem>
                                    <MenuItem value="Divorced">Divorced</MenuItem>
                                    <MenuItem value="Widowed">Widowed</MenuItem>
                                  </TextField>
                                </Grid>
                              )}
                            </Grid>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={handleCloseRespondentForm}>Cancel</Button>
                            <Button onClick={handleSaveRespondent} variant="contained" color="primary">Save</Button>
                          </DialogActions>
                        </Dialog>
                      </Box>
                    )}

                    {/* APPOINTED TRUSTEES / LIQUIDATORS SECTION */}
                    <Box sx={containerStyle}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                          {isNPAClassification ? 'Appointed Curator' : (formData.estateClassification === 'Person' ? 'Appointed Trustees' : 'Appointed Liquidators')}
                        </Typography>

                        <Stack direction="row" spacing={1}>
                          <Button 
                            variant="outlined"
                            onClick={() => setManageDirectoryOpen(true)}
                            disabled={!isEditingMode || user?.role === 'guest'}
                          >
                            Directory
                          </Button>
                          <Button 
                            variant="contained"
                            startIcon={<AddCircleOutlineIcon />}
                            onClick={() => handleOpenTrusteeForm(numTrustees < 8 ? numTrustees + 1 : 8)} 
                            disabled={!isEditingMode || numTrustees >= 8 || user?.role === 'guest'}
                          >
                            Add {isNPAClassification ? 'Curator' : 'Appointee'}
                          </Button>
                        </Stack>
                      </Stack>

                      <TableContainer component={Paper} variant="outlined">
                        <Table size="small">
                          <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                            <TableRow>
                              <TableCell sx={{ fontWeight: 'bold', width: '5%' }}>#</TableCell>
                              <TableCell sx={{ fontWeight: 'bold', width: '20%' }}>Firm Name</TableCell>
                              <TableCell sx={{ fontWeight: 'bold', width: '20%' }}>Full Name & Surname</TableCell>
                              <TableCell sx={{ fontWeight: 'bold', width: '15%' }}>Cell Number</TableCell>
                              <TableCell sx={{ fontWeight: 'bold', width: '20%' }}>Email Address</TableCell>
                              <TableCell sx={{ fontWeight: 'bold', width: '10%' }}>VAT</TableCell>
                              <TableCell sx={{ fontWeight: 'bold', width: '10%' }}>Actions</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {Array.from({ length: numTrustees }, (_, index) => index + 1).map(i => {
                              const firmName = formData[`trustee${i}FirmName`];
                              const fullName = formData[`trustee${i}FullName`];
                              const phone = formData[`trustee${i}Telephone`];
                              const email = formData[`trustee${i}Email`];
                              const vatReg = formData[`trustee${i}VatRegistered`];
                              const vatNum = formData[`trustee${i}VatNumber`];

                              return (
                                <TableRow key={i} hover>
                                  <TableCell>{i}</TableCell>
                                  <TableCell>{firmName || '-'}</TableCell>
                                  <TableCell>{fullName || '-'}</TableCell>
                                  <TableCell>{phone || '-'}</TableCell>
                                  <TableCell>
                                    {email ? (
                                      <Stack direction="row" alignItems="center" spacing={1}>
                                        <Box>
                                          {email.split(/[,;]+/).map((e, idx) => (
                                            <Typography key={idx} variant="body2">{e.trim()}</Typography>
                                          ))}
                                        </Box>
                                        <IconButton size="small" color="primary" onClick={() => window.location.href = `mailto:${email.replace(/;/g, ',')}`}>
                                          <MailOutlineIcon fontSize="small" />
                                        </IconButton>
                                      </Stack>
                                    ) : '-'}
                                  </TableCell>
                                  <TableCell>
                                    {vatReg === true || vatReg === 'true' ? `Yes${vatNum ? ` - ${vatNum}` : ''}` : 'No'}
                                  </TableCell>
                                  <TableCell>
                                    <Stack direction="row" spacing={1}>
                                      <IconButton color="primary" size="small" disabled={!isEditingMode || user?.role === 'guest'} onClick={() => handleOpenTrusteeForm(i)}>
                                        <EditIcon fontSize="small" />
                                      </IconButton>
                                      <IconButton color="error" size="small" disabled={!isEditingMode || user?.role === 'guest'} onClick={() => handleDeleteTrustee(i)}>
                                        <DeleteIcon fontSize="small" />
                                      </IconButton>
                                    </Stack>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                            {numTrustees === 0 && (
                              <TableRow>
                                <TableCell colSpan={7} align="center" sx={{ py: 3, fontStyle: 'italic', color: 'text.secondary' }}>
                                  No {isNPAClassification ? 'curators' : 'appointees'} added. Click "Add {isNPAClassification ? 'Curator' : 'Appointee'}" above to begin.
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>

                      <Box sx={{ marginTop: 2, display: 'flex', gap: 2 }}>
                        <Button
                          variant="outlined"
                          size="small"
                          startIcon={<MailOutlineIcon />}
                          disabled={user?.role === 'guest' || getEmails().length === 0}
                          onClick={() => {
                            const emails = getEmails(); 
                            if (emails.length) {
                              window.location.href = `mailto:${emails.join(';')}`;
                            }
                          }}
                        >
                          Email All ({getEmails().length})
                        </Button>
                      </Box>

                      {/* Dialog for Add/Edit Trustee */}
                      <Dialog open={trusteeFormOpen} onClose={handleCloseTrusteeForm} fullWidth maxWidth="sm">
                        <DialogTitle>
                          {editingTrusteeIndex > numTrustees ? 'Add ' : 'Edit '}
                          {isNPAClassification ? 'Curator' : 'Appointee'}
                        </DialogTitle>
                        <DialogContent dividers>
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <Autocomplete
                                options={Array.isArray(trusteeDirectory) ? trusteeDirectory : []}
                                getOptionLabel={(option) => `${option.fullName} ${option.firmName ? `(${option.firmName})` : ''}`}
                                onChange={(e, value) => {
                                  if (value) {
                                    setTrusteeForm({
                                      ...trusteeForm,
                                      firmName: value.firmName || '',
                                      fullName: value.fullName || '',
                                      phone: value.phone || '',
                                      email: value.email || '',
                                      vatRegistered: value.vatRegistered || false,
                                      vatNumber: value.vatNumber || ''
                                    });
                                  }
                                }}
                                renderInput={(params) => <TextField {...params} label="Load from Directory..." size="small" />}
                              />
                            </Grid>
                            <Grid item xs={12}><Divider /></Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField fullWidth size="small" label="Firm Name" value={trusteeForm.firmName || ''} onChange={(e) => setTrusteeForm({ ...trusteeForm, firmName: e.target.value })} sx={{ mt: 1 }} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField fullWidth size="small" label="Full Name & Surname" value={trusteeForm.fullName || ''} onChange={(e) => setTrusteeForm({ ...trusteeForm, fullName: e.target.value })} sx={{ mt: 1 }} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField fullWidth size="small" label="Cell Number" value={trusteeForm.phone || ''} onChange={(e) => setTrusteeForm({ ...trusteeForm, phone: e.target.value })} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField fullWidth size="small" label="Email Address(es)" value={trusteeForm.email || ''} onChange={(e) => setTrusteeForm({ ...trusteeForm, email: e.target.value })} helperText="Separate multiple emails with commas" />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <FormControlLabel control={<Checkbox checked={trusteeForm.vatRegistered} onChange={(e) => setTrusteeForm({ ...trusteeForm, vatRegistered: e.target.checked })} />} label={<Typography variant="body2">VAT Registered</Typography>} />
                            </Grid>
                            {trusteeForm.vatRegistered && (
                              <Grid item xs={12} sm={6}>
                                <TextField fullWidth size="small" label="VAT Number" value={trusteeForm.vatNumber || ''} onChange={(e) => setTrusteeForm({ ...trusteeForm, vatNumber: e.target.value })} />
                              </Grid>
                            )}
                            <Grid item xs={12}>
                              <FormControlLabel control={<Checkbox checked={trusteeForm.saveToDirectory || false} onChange={(e) => setTrusteeForm({ ...trusteeForm, saveToDirectory: e.target.checked })} />} label={<Typography variant="body2">Save / Update this contact in directory</Typography>} />
                            </Grid>
                          </Grid>
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={handleCloseTrusteeForm}>Cancel</Button>
                          <Button onClick={handleSaveTrustee} variant="contained" color="primary">Save</Button>
                        </DialogActions>
                      </Dialog>

                      {/* Manage Directory Dialog */}
                      <Dialog open={manageDirectoryOpen} onClose={() => setManageDirectoryOpen(false)} fullWidth maxWidth="md">
                        <DialogTitle>Trustee & Liquidator Directory</DialogTitle>
                        <DialogContent dividers>
                          <TableContainer component={Paper} variant="outlined">
                            <Table size="small">
                              <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                                <TableRow>
                                  <TableCell sx={{ fontWeight: 'bold' }}>Full Name</TableCell>
                                  <TableCell sx={{ fontWeight: 'bold' }}>Firm Name</TableCell>
                                  <TableCell sx={{ fontWeight: 'bold' }}>Email</TableCell>
                                  <TableCell sx={{ fontWeight: 'bold' }}>Phone</TableCell>
                                  <TableCell sx={{ fontWeight: 'bold', width: '10%' }}>Actions</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {(Array.isArray(trusteeDirectory) ? trusteeDirectory : []).map((contact, idx) => (
                                  <TableRow key={idx}>
                                    <TableCell>{contact.fullName}</TableCell>
                                    <TableCell>{contact.firmName}</TableCell>
                                    <TableCell>{contact.email}</TableCell>
                                    <TableCell>{contact.phone}</TableCell>
                                    <TableCell>
                                      <IconButton size="small" color="error" onClick={() => handleDeleteFromDirectory(contact.fullName)}>
                                        <DeleteIcon fontSize="small" />
                                      </IconButton>
                                    </TableCell>
                                  </TableRow>
                                ))}
                                {trusteeDirectory.length === 0 && (
                                  <TableRow>
                                    <TableCell colSpan={5} align="center" sx={{ py: 3, fontStyle: 'italic', color: 'text.secondary' }}>
                                      Directory is empty. Save contacts when adding/editing trustees to populate this list.
                                    </TableCell>
                                  </TableRow>
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={() => setManageDirectoryOpen(false)}>Close</Button>
                        </DialogActions>
                      </Dialog>
                    </Box>

                    {/* APPLICANT & ATTORNEYS INFORMATION */}
                    {(formData.estateClassification !== 'NPA' && !isVoluntary) && (
                      <Box sx={{ ...containerStyle, marginTop: 4 }}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                            {isInsolvencyOrLiquidation && isVoluntary ? 'Attorney Handling Voluntary Application' : 'Applicant & Attorney Information'}
                          </Typography>
                          <Stack direction="row" spacing={1}>
                            <Button 
                              variant="outlined" 
                              onClick={() => setManageAttorneyDirectoryOpen(true)} 
                              disabled={!isEditingMode || user?.role === 'guest'}
                            >
                              Directory
                            </Button>
                            <Button 
                              variant="contained" 
                              onClick={handleSaveAttorneyToDirectory} 
                              disabled={!isEditingMode || user?.role === 'guest' || !formData.attorneyName}
                            >
                              Save Attorney
                            </Button>
                          </Stack>
                        </Stack>
                        <Grid container spacing={2}>
                          {isVoluntary && isInsolvencyOrLiquidation && (
                            <Grid item xs={12}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    name="applicantIsDebtor"
                                    checked={formData.applicantIsDebtor || false}
                                    onChange={handleFieldChange}
                                    disabled={!isEditingMode || user?.role === 'guest'}
                                  />
                                }
                                label="The Applicant is the Debtor/Insolvent (No separate applicant)"
                              />
                            </Grid>
                          )}
                          {(!isVoluntary || (isVoluntary && !formData.applicantIsDebtor)) && (
                            <>
                              <Grid item xs={12} sm={6}><TextField fullWidth label="Applicant Name (Entity/Individual)" name="applicantName" value={formData.applicantName || ''} onChange={handleFieldChange} disabled={!isEditingMode} /></Grid>
                              <Grid item xs={12} sm={3}><TextField fullWidth label="Contact Number" name="applicantPhone" value={formData.applicantPhone || ''} onChange={handleFieldChange} disabled={!isEditingMode} /></Grid>
                              <Grid item xs={12} sm={3}><TextField fullWidth label="Email Address" name="applicantEmail" value={formData.applicantEmail || ''} onChange={handleFieldChange} disabled={!isEditingMode} /></Grid>
                              <Grid item xs={12}><TextField fullWidth label="Physical & Postal Address" multiline rows={2} name="applicantAddress" value={formData.applicantAddress || ''} onChange={handleFieldChange} disabled={!isEditingMode} /></Grid>
                            </>
                          )}

                          <Grid item xs={12}>
                            <Autocomplete
                              options={Array.isArray(attorneyDirectory) ? attorneyDirectory : []}
                              getOptionLabel={(option) => `${option.fullName} ${option.firmName ? `(${option.firmName})` : ''}`}
                              onChange={(e, value) => {
                                if (value) {
                                  const updates = {
                                    attorneyFirm: value.firmName || '',
                                    attorneyName: value.fullName || '',
                                    attorneyPhone: value.phone || '',
                                    attorneyEmail: value.email || '',
                                  };
                                  setFormData(prev => ({ ...prev, ...updates }));
                                  setUpdatedMatter(prev => ({ ...prev, ...updates }));
                                }
                              }}
                              renderInput={(params) => <TextField {...params} label="Load Attorney from Directory..." size="small" />}
                              disabled={!isEditingMode || user?.role === 'guest'}
                            />
                          </Grid>

                          <Grid item xs={12} sm={4}><TextField fullWidth label="Firm's Name" name="attorneyFirm" value={formData.attorneyFirm || ''} onChange={handleFieldChange} disabled={!isEditingMode} /></Grid>
                          <Grid item xs={12} sm={4}><TextField fullWidth label="Attorney's Name" name="attorneyName" value={formData.attorneyName || ''} onChange={handleFieldChange} disabled={!isEditingMode} /></Grid>
                          <Grid item xs={12} sm={4}><TextField fullWidth label="Reference Number" name="attorneyRef" value={formData.attorneyRef || ''} onChange={handleFieldChange} disabled={!isEditingMode} /></Grid>
                          <Grid item xs={12} sm={6}><TextField fullWidth label="Contact Number" name="attorneyPhone" value={formData.attorneyPhone || ''} onChange={handleFieldChange} disabled={!isEditingMode} /></Grid>
                          <Grid item xs={12} sm={6}><TextField fullWidth label="Email Address" name="attorneyEmail" value={formData.attorneyEmail || ''} onChange={handleFieldChange} disabled={!isEditingMode} /></Grid>

                          <Grid item xs={12} sm={4}>
                            <TextField 
                              select 
                              fullWidth 
                              label="Will submit Taxed Bill" 
                              name="willSubmitTaxedBill" 
                              value={formData.willSubmitTaxedBill === true || formData.willSubmitTaxedBill === "1" || formData.willSubmitTaxedBill === 1 || String(formData.willSubmitTaxedBill) === "true" ? 'true' : 'false'} 
                              onChange={(e) => handleFieldChange({ target: { name: 'willSubmitTaxedBill', value: e.target.value === 'true', type: 'checkbox' }})} 
                              disabled={!isEditingMode}
                            >
                              <MenuItem value="true">Yes</MenuItem>
                              <MenuItem value="false">No</MenuItem>
                            </TextField>
                          </Grid>
                          
                          {(formData.willSubmitTaxedBill === true || formData.willSubmitTaxedBill === "1" || formData.willSubmitTaxedBill === 1 || String(formData.willSubmitTaxedBill) === "true") && (
                            <>
                              <Grid item xs={12} sm={4}>
                                <TextField 
                                  fullWidth 
                                  label="Taxed Bill Amount" 
                                  name="taxedBillAmount" 
                                  type="number" 
                                  InputProps={{ startAdornment: <Typography variant="body2" sx={{ mr: 1 }}>R</Typography> }} 
                                  value={formData.taxedBillAmount || ''} 
                                  onChange={handleFieldChange} 
                                  disabled={!isEditingMode}
                                />
                              </Grid>
                              <Grid item xs={12} sm={4} sx={{ display: 'flex', alignItems: 'center' }}>
                                <FormControlLabel
                                  control={<Checkbox name="taxedBillObtained" checked={formData.taxedBillObtained === true || formData.taxedBillObtained === "1" || formData.taxedBillObtained === 1 || String(formData.taxedBillObtained) === "true"} onChange={handleFieldChange} disabled={!isEditingMode} />}
                                  label="Paid"
                                />
                              </Grid>
                            </>
                          )}
                        </Grid>
                      </Box>
                    )}

                    {/* Manage Attorney Directory Dialog */}
                    <Dialog open={manageAttorneyDirectoryOpen} onClose={() => setManageAttorneyDirectoryOpen(false)} fullWidth maxWidth="md">
                      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        Attorney Directory
                        <Button 
                          variant="contained" 
                          size="small" 
                          startIcon={<AddCircleOutlineIcon />} 
                          onClick={() => {
                            setAttorneyForm({ originalName: '', firmName: '', fullName: '', phone: '', email: '' });
                            setAddAttorneyFormOpen(true);
                          }}
                        >
                          Add Attorney
                        </Button>
                      </DialogTitle>
                      <DialogContent dividers>
                        <TableContainer component={Paper} variant="outlined">
                          <Table size="small">
                            <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                              <TableRow>
                                <TableCell sx={{ fontWeight: 'bold' }}>Full Name</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Firm Name</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Email</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Phone</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '10%' }}>Actions</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {(Array.isArray(attorneyDirectory) ? attorneyDirectory : []).map((contact, idx) => (
                                <TableRow key={idx}>
                                  <TableCell>{contact.fullName}</TableCell>
                                  <TableCell>{contact.firmName}</TableCell>
                                  <TableCell>{contact.email}</TableCell>
                                  <TableCell>{contact.phone}</TableCell>
                                  <TableCell>
                                    <Stack direction="row" spacing={1}>
                                      <IconButton size="small" color="primary" onClick={() => handleEditAttorneyInDirectory(contact)}>
                                        <EditIcon fontSize="small" />
                                      </IconButton>
                                      <IconButton size="small" color="error" onClick={() => handleDeleteFromAttorneyDirectory(contact.fullName)}>
                                        <DeleteIcon fontSize="small" />
                                      </IconButton>
                                    </Stack>
                                  </TableCell>
                                </TableRow>
                              ))}
                              {attorneyDirectory.length === 0 && (
                                <TableRow>
                                  <TableCell colSpan={5} align="center" sx={{ py: 3, fontStyle: 'italic', color: 'text.secondary' }}>
                                    Directory is empty. Click "Add Attorney" to populate this list.
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={() => setManageAttorneyDirectoryOpen(false)}>Close</Button>
                      </DialogActions>
                    </Dialog>

                    {/* Add / Edit Attorney Dialog */}
                    <Dialog open={addAttorneyFormOpen} onClose={() => setAddAttorneyFormOpen(false)} fullWidth maxWidth="sm">
                      <DialogTitle>{attorneyForm.originalName ? 'Edit Attorney' : 'Add Attorney to Directory'}</DialogTitle>
                      <DialogContent dividers>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <TextField fullWidth size="small" label="Firm Name" value={attorneyForm.firmName} onChange={e => setAttorneyForm({...attorneyForm, firmName: e.target.value})} sx={{ mt: 1 }} />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField fullWidth size="small" label="Full Name" value={attorneyForm.fullName} onChange={e => setAttorneyForm({...attorneyForm, fullName: e.target.value})} sx={{ mt: 1 }} />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField fullWidth size="small" label="Phone" value={attorneyForm.phone} onChange={e => setAttorneyForm({...attorneyForm, phone: e.target.value})} />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField fullWidth size="small" label="Email" value={attorneyForm.email} onChange={e => setAttorneyForm({...attorneyForm, email: e.target.value})} />
                          </Grid>
                        </Grid>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={() => setAddAttorneyFormOpen(false)}>Cancel</Button>
                        <Button onClick={handleSaveNewAttorneyToDirectory} variant="contained" color="primary" disabled={!attorneyForm.fullName}>Save</Button>
                      </DialogActions>
                    </Dialog>

                    {/* BOND SECURITY SECTION */}
                    <Box sx={containerStyle}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ marginBottom: 2 }}>
                        <Typography variant="h6">Bond Security Information </Typography>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          onClick={handleAddBondEntry}
                          disabled={!isEditingMode || user?.role === 'guest' || editingBondId}
                        >
                          Add New Bond
                        </Button>
                      </Stack>

                      {editingBondId && bondForm && (
                        <Paper elevation={3} sx={{ p: 3, mb: 3, borderTop: `4px solid ${theme.palette.primary.main}`, bgcolor: '#fcfcfc' }}>
                          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2 }}>
                            {editingBondId === 'NEW' ? 'Add New Bond Entry' : 'Edit Bond Entry'}
                          </Typography>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                select
                                fullWidth label="Insurance Name" name="insurerName"
                                value={bondForm.insurerName || ''}
                                onChange={handleBondFormChange}
                                variant="outlined" disabled={!isEditingMode}
                              >
                                {bondForm.insurerName && !INSURER_OPTIONS.includes(bondForm.insurerName) && (
                                  <MenuItem value={bondForm.insurerName}>{bondForm.insurerName}</MenuItem>
                                )}
                                {INSURER_OPTIONS.map(opt => (
                                  <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                ))}
                              </TextField>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                fullWidth label="Policy Number" name="policyNumber"
                                value={bondForm.policyNumber || ''}
                                onChange={handleBondFormChange}
                                variant="outlined" disabled={!isEditingMode}
                              />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                              <TextField
                                fullWidth label={isFirstBondEntry ? "Inception Date" : "Renewal Date"} name="inceptionDate" type="date"
                                value={bondForm.inceptionDate || ''}
                                onChange={handleBondFormChange}
                                variant="outlined" disabled={!isEditingMode}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ max: '9999-12-31' }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                              <TextField
                                fullWidth label={isFirstBondEntry ? "Policy Renewal Date" : "Next Renewal Date"} name="policyRenewalDate" type="date"
                                value={bondForm.policyRenewalDate || ''}
                                onChange={handleBondFormChange}
                                variant="outlined" disabled={!isEditingMode}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ max: '9999-12-31' }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={4} sx={{ display: 'flex', alignItems: 'center' }}>
                              <FormControlLabel
                                control={
                                  <Checkbox name="isPaid" checked={bondForm.isPaid === true || bondForm.isPaid === "1" || bondForm.isPaid === 1 || String(bondForm.isPaid) === "true"} onChange={handleBondFormChange} disabled={!isEditingMode} />
                                }
                                label="Paid"
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <TextField
                                fullWidth label="Initial Insured Amount" name="insuredAmount" type="text"
                                value={bondForm.insuredAmount || ''}
                                onChange={handleBondFormChange}
                                variant="outlined" disabled={!isEditingMode}
                                InputProps={{ startAdornment: <Typography sx={{ mr: 1 }}>R</Typography> }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <TextField
                                fullWidth label="Reduction/Increase Amount" name="finalInsuredAmount" type="text"
                                value={bondForm.finalInsuredAmount || ''}
                                onChange={handleBondFormChange}
                                variant="outlined" disabled={!isEditingMode}
                                InputProps={{ startAdornment: <Typography sx={{ mr: 1 }}>R</Typography> }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <TextField
                                fullWidth label="Reduction/Increase Date" name="reductionIncreaseDate" type="date"
                                value={bondForm.reductionIncreaseDate || ''}
                                onChange={handleBondFormChange}
                                variant="outlined" disabled={!isEditingMode}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ max: '9999-12-31' }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <TextField
                                fullWidth
                                label={isNPAClassification ? "Annual Bond Premium (incl. VAT)" : "Annual Bond Premium"}
                                name="annualBondPremium" type="text"
                                value={
                                  (bondForm.insuredAmount || bondForm.finalInsuredAmount)
                                    ? ((parseMoney(bondForm.insuredAmount) + parseMoney(bondForm.finalInsuredAmount)) * (isNPAClassification ? 0.006 * 1.15 : 0.00575)).toFixed(2)
                                    : ''
                                }
                                variant="outlined" disabled
                                InputProps={{ startAdornment: <Typography sx={{ mr: 1 }}>R</Typography> }}
                              />
                            </Grid>
                          </Grid>
                          <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 2 }}>
                            <Button variant="outlined" onClick={handleCancelBondForm}>Cancel</Button>
                            <Button variant="contained" color="primary" onClick={handleSaveBondForm}>Save Bond Entry</Button>
                          </Stack>
                        </Paper>
                      )}

                      {/* SUMMARY TABLE */}
                      <Box sx={{ mt: editingBondId ? 4 : 0 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1, color: 'text.secondary' }}>
                          Bond Entries Summary
                        </Typography>
                        <TableContainer component={Paper} variant="outlined">
                          <Table size="small">
                            <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                              <TableRow>
                                <TableCell sx={{ fontWeight: 'bold' }}>Insurer Name & Policy</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Dates</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', textAlign: 'right' }}>Insured Amount</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', textAlign: 'right' }}>Inc / Red Amount</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', textAlign: 'right' }}>{isNPAClassification ? 'Annual Premium (incl. VAT)' : 'Annual Premium'}</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Paid</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Actions</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {(Array.isArray(bondEntries) ? bondEntries : []).map((entry) => {
                                // Trusts & Curatorship's (NPA/NDPP matters): 0.6% + VAT of the total bond amount p.a.
                                // Liquidation matters: 0.575% of the total bond amount p.a. (no VAT)
                                const premiumRate = isNPAClassification ? 0.006 * 1.15 : 0.00575;
                                const premium = ((parseMoney(entry.insuredAmount) + parseMoney(entry.finalInsuredAmount)) * premiumRate).toFixed(2);
                                return (
                                  <TableRow 
                                    key={entry.id} 
                                    hover 
                                    sx={{ cursor: 'pointer' }}
                                    onClick={() => handleEditBondEntry(entry)}
                                  >
                                    <TableCell>
                                      <Typography variant="body2" sx={{ fontWeight: 'bold' }}>{entry.insurerName || '---'}</Typography>
                                      <Typography variant="caption" color="text.secondary">{entry.policyNumber || '---'}</Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="caption" display="block">
                                        <strong>{bondEntries.indexOf(entry) === 0 ? 'Inception:' : 'Renewal:'}</strong> {entry.inceptionDate ? displayDate(entry.inceptionDate) : '---'}
                                      </Typography>
                                      <Typography variant="caption" display="block">
                                        <strong>{bondEntries.indexOf(entry) === 0 ? 'Renewal:' : 'Next Renewal:'}</strong> {entry.policyRenewalDate ? displayDate(entry.policyRenewalDate) : '---'}
                                      </Typography>
                                      <Typography variant="caption" display="block" color="text.secondary"><strong>Revision:</strong> {entry.reductionIncreaseDate ? displayDate(entry.reductionIncreaseDate) : '---'}</Typography>
                                    </TableCell>
                                    <TableCell align="right">
                                      {entry.insuredAmount ? formatMoney(entry.insuredAmount) : 'R 0.00'}
                                    </TableCell>
                                    <TableCell align="right">
                                      {entry.finalInsuredAmount ? formatMoney(entry.finalInsuredAmount) : 'R 0.00'}
                                    </TableCell>
                                    <TableCell align="right">
                                      {formatMoney(premium)}
                                    </TableCell>
                                    <TableCell align="center">
                                      <Chip 
                                        label={entry.isPaid === true || entry.isPaid === "1" || entry.isPaid === 1 || String(entry.isPaid) === "true" ? 'Paid' : 'Pending'} 
                                        color={entry.isPaid === true || entry.isPaid === "1" || entry.isPaid === 1 || String(entry.isPaid) === "true" ? 'success' : 'warning'} 
                                        size="small" 
                                        variant="outlined" 
                                        sx={{ fontWeight: 'bold' }} 
                                      />
                                    </TableCell>
                                    <TableCell align="center">
                                      <Stack direction="row" spacing={1} justifyContent="center">
                                        <IconButton size="small" color="primary" onClick={(e) => { e.stopPropagation(); handleEditBondEntry(entry); }} disabled={!isEditingMode || user?.role === 'guest'}><EditIcon fontSize="small" /></IconButton>
                                        <IconButton size="small" color="error" onClick={(e) => handleRemoveBondEntry(entry.id, e)} disabled={!isEditingMode || user?.role === 'guest'}><DeleteIcon fontSize="small" /></IconButton>
                                      </Stack>
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                              {bondEntries.length === 0 && (
                                <TableRow>
                                  <TableCell colSpan={7} align="center" sx={{ py: 3, fontStyle: 'italic', color: 'text.secondary' }}>
                                    No bond entries recorded. Click "Add New Bond" above.
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                    </Box>

                    {/* L&D EXTENSIONS TABLE - not applicable to NPA matters */}
                    {!isNPAClassification && (
                    <Box sx={{ ...containerStyle, marginTop: 4 }}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                          L&D Account Extensions
                        </Typography>
                        <Button
                          variant="contained"
                          startIcon={<AddCircleOutlineIcon />}
                          disabled={!isEditingMode || user?.role === 'guest'}
                          onClick={() => {
                            const extensions = formData.ldExtensions || [];
                            let newDueDate = '';

                            if (extensions.length === 0) {
                              if (formData.finalAppointmentDate) {
                                const baseDate = new Date(formData.finalAppointmentDate);
                                baseDate.setMonth(baseDate.getMonth() + 6);
                                newDueDate = baseDate.toISOString().split('T')[0];
                              }
                            } else {
                              const lastExtension = extensions[extensions.length - 1];
                              if (lastExtension.grantedUntil) {
                                newDueDate = lastExtension.grantedUntil;
                              }
                            }

                            const newExt = {
                              id: Date.now(),
                              accountDueDate: newDueDate,
                              dateOfApplication: '',
                              dateGranted: '',
                              grantedUntil: '',
                              extensionGranted: false,
                              document: null,
                            };
                            const updatedList = [...extensions, newExt];
                            handleFieldChange({ target: { name: 'ldExtensions', value: updatedList, type: 'array' } });
                          }}
                        >
                          Add Extension
                        </Button>
                      </Stack>

                      <TableContainer component={Paper} variant="outlined">
                        <Table size="small">
                          <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                            <TableRow>
                              <TableCell sx={{ fontWeight: 'bold', width: '5%' }}>#</TableCell>
                              <TableCell sx={{ fontWeight: 'bold', width: '15%' }}>Account Due Date</TableCell>
                              <TableCell sx={{ fontWeight: 'bold', width: '15%' }}>Date of Application</TableCell>
                              <TableCell sx={{ fontWeight: 'bold', width: '15%' }}>Date Granted</TableCell>
                              <TableCell sx={{ fontWeight: 'bold', width: '15%' }}>Granted Until</TableCell>
                              <TableCell sx={{ fontWeight: 'bold', width: '25%' }}>Extension Granted by Master</TableCell>
                              <TableCell sx={{ fontWeight: 'bold', width: '10%' }}>Actions</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(Array.isArray(formData.ldExtensions) ? formData.ldExtensions : []).map((row, index) => (
                              <TableRow key={row.id || index}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>
                                  <TextField
                                    fullWidth size="small" type="date"
                                    value={row.accountDueDate || ''}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => {
                                      const updatedList = [...formData.ldExtensions];
                                      updatedList[index] = { ...updatedList[index], accountDueDate: e.target.value };
                                      handleFieldChange({ target: { name: 'ldExtensions', value: updatedList, type: 'array' } });
                                    }}
                                    inputProps={{ max: '9999-12-31' }}
                                    disabled={!isEditingMode || user?.role === 'guest'}
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextField 
                                    fullWidth size="small" type="date" 
                                    value={row.dateOfApplication || ''} 
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => {
                                      const updatedList = [...formData.ldExtensions];
                                      updatedList[index] = { ...updatedList[index], dateOfApplication: e.target.value };
                                      handleFieldChange({ target: { name: 'ldExtensions', value: updatedList, type: 'array' } });
                                    }}
                                    inputProps={{ max: '9999-12-31' }}
                                    disabled={!isEditingMode || user?.role === 'guest'}
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextField 
                                    fullWidth size="small" type="date" 
                                    value={row.dateGranted || ''} 
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => {
                                      const updatedList = [...formData.ldExtensions];
                                      updatedList[index] = { ...updatedList[index], dateGranted: e.target.value };
                                      handleFieldChange({ target: { name: 'ldExtensions', value: updatedList, type: 'array' } });
                                    }}
                                    inputProps={{ max: '9999-12-31' }}
                                    disabled={!isEditingMode || user?.role === 'guest'}
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextField 
                                    fullWidth size="small" type="date" 
                                    value={row.grantedUntil || ''} 
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => {
                                      const updatedList = [...formData.ldExtensions];
                                      updatedList[index] = { ...updatedList[index], grantedUntil: e.target.value };
                                      handleFieldChange({ target: { name: 'ldExtensions', value: updatedList, type: 'array' } });
                                    }}
                                    inputProps={{ max: '9999-12-31' }}
                                    disabled={!isEditingMode || user?.role === 'guest'}
                                  />
                                </TableCell>
                                <TableCell>
                                  <Stack direction="row" alignItems="center" spacing={1}>
                                    <Checkbox
                                      size="small"
                                      checked={row.extensionGranted || false}
                                      onChange={(e) => {
                                        const updatedList = [...formData.ldExtensions];
                                        updatedList[index] = { ...updatedList[index], extensionGranted: e.target.checked };
                                        handleFieldChange({ target: { name: 'ldExtensions', value: updatedList, type: 'array' } });
                                      }}
                                      disabled={!isEditingMode || user?.role === 'guest'}
                                    />
                                    {row.extensionGranted && (
                                      row.document ? (
                                        <Button size="small" variant="text" onClick={() => handleOpenPreview(row.document)}>View</Button>
                                      ) : (
                                        <Button
                                          component="label"
                                          size="small"
                                          variant="outlined"
                                          disabled={!isEditingMode}
                                        >
                                          Attach
                                          <input
                                            type="file"
                                            hidden
                                            onChange={async (e) => {
                                              const file = e.target.files[0];
                                              if (!file) return;
                                              const updatedList = [...formData.ldExtensions];
                                              updatedList[index] = { ...updatedList[index], document: { filename: file.name } };
                                              handleFieldChange({ target: { name: 'ldExtensions', value: updatedList, type: 'array' } });
                                            }}
                                          />
                                        </Button>
                                      )
                                    )}
                                  </Stack>
                                </TableCell>
                                <TableCell>
                                  <IconButton color="error" size="small" disabled={!isEditingMode || user?.role === 'guest'} onClick={() => {
                                    const filtered = formData.ldExtensions.filter((_, i) => i !== index);
                                    handleFieldChange({ target: { name: 'ldExtensions', value: filtered, type: 'array' } });
                                  }}>
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            ))}
                            {(!formData.ldExtensions || formData.ldExtensions.length === 0) && (
                              <TableRow><TableCell colSpan={7} align="center" sx={{ py: 3, fontStyle: 'italic', color: 'text.secondary' }}>No L&D extensions recorded.</TableCell></TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                    )}

                    {/* CONDITIONAL AFU OFFICE SECTION */}
                    {isNPAClassification && (
                      <Box sx={containerStyle}>
                        <Typography variant="h6" sx={{ marginBottom: 2 }}>
                          AFU Information
                        </Typography>
                        <Grid container spacing={2}>
                          {[
                            { label: 'AFU Name', name: 'afuName', sm: 4 },
                            { label: 'AFU Surname', name: 'afuSurname', sm: 4 },
                            { label: 'AFU Office', name: 'afuOffice', type: 'select', options: AFU_OFFICE_OPTIONS, sm: 4 },
                            { label: 'AFU Contact', name: 'afuContact', sm: 6 },
                            { label: 'AFU Email', name: 'afuEmail', sm: 6 },
                          ].map(({ label, name, type, options, sm }) => (
                            <Grid item xs={12} sm={sm} key={name}>
                              {type === 'select' ? (
                                <FormControl fullWidth variant="outlined" disabled={!isEditingMode || user?.role === 'guest'}>
                                  <InputLabel id={`afu-${name}-label`}>{label}</InputLabel>
                                  <Select
                                    labelId={`afu-${name}-label`}
                                    label={label}
                                    name={name}
                                    value={formData[name] || ''}
                                    onChange={handleFieldChange}
                                  >
                                    {options.map((option) => (
                                      <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              ) : (
                                <TextField
                                  fullWidth
                                  label={label}
                                  name={name}
                                  value={formData[name] || ''}
                                  onChange={handleFieldChange}
                                  variant="outlined"
                                  disabled={!isEditingMode || user?.role === 'guest'}
                                  InputLabelProps={{ shrink: !!formData[name] }}
                                />
                              )}
                            </Grid>
                          ))}
                        </Grid>
                      </Box>
                    )}
                  </React.Fragment>
                );
              })()}
            </Box>
          )}

          {/* OTHER TABS CONTENT */}
          {value === ESTATE_ACCOUNT_INDEX && ESTATE_ACCOUNT_INDEX !== -1 && <CashbookTransactionsTab matter={matter} onSummaryUpdate={handleCashbookSummary} />}

          {value === LD_ACCOUNT_INDEX && LD_ACCOUNT_INDEX !== -1 && <AccountsTab matter={matter} />}

          {value === DRAFT_ACCOUNTS_INDEX && DRAFT_ACCOUNTS_INDEX !== -1 && <NPAAccountsTab matter={matter} mode="draft" />}

          {value === FINAL_ACCOUNTS_INDEX && FINAL_ACCOUNTS_INDEX !== -1 && <NPAAccountsTab matter={matter} mode="final" />}

          {value === MEETINGS_INDEX && MEETINGS_INDEX !== -1 && (
            <AppointmentsTab matter={matter} isNPAClassification={formData.estateClassification === 'NPA' || formData.estateClassification === 'Npa Matters' || formData.estateClassification === 'Curator Appointments'} />
          )}

          {value === CURATOR_REPORT_INDEX && CURATOR_REPORT_INDEX !== -1 && (
            <CuratorReportTab
              formData={formData}
              handleFieldChange={handleFieldChange}
              isEditingMode={isEditingMode}
              user={user}
              matterId={id}
            />
          )}

          {value === ASSETS_INDEX && ASSETS_INDEX !== -1 && (
            <AssetsTab matter={{ ...matter, respondents: formData.respondents }} />
          )}

          {value === CLAIMS_INDEX && CLAIMS_INDEX !== -1 && (
            <ClaimsTab
              formData={formData} 
              handleFieldChange={handleFieldChange} 
              isEditingMode={isEditingMode} 
              user={user} 
              matterId={id}
            />
          )}

          {value === DEBTORS_INDEX && DEBTORS_INDEX !== -1 && (
            <DebtorsTab
              formData={formData} 
              handleFieldChange={handleFieldChange} 
              isEditingMode={isEditingMode} 
              user={user} 
              matterId={id}
            />
          )}

          {value === ASSET_INSURANCE_INDEX && ASSET_INSURANCE_INDEX !== -1 && (
            <AssetInsuranceTab
              formData={formData} 
              handleFieldChange={handleFieldChange} 
              isEditingMode={isEditingMode} 
              user={user} 
              matterId={id}
            />
          )}

          {value === ENQUIRY_INDEX && ENQUIRY_INDEX !== -1 && (
            <EnquiryTab
              formData={formData} 
              handleFieldChange={handleFieldChange} 
              isEditingMode={isEditingMode} 
              user={user} 
              matterId={id}
              setDocuments={setDocuments}
            />
          )}

          {value === TASKS_INDEX && TASKS_INDEX !== -1 && (
            <TasksTab
              formData={formData} 
              handleFieldChange={handleFieldChange} 
              isEditingMode={isEditingMode} 
              user={user} 
              matterId={id}
            />
          )}

          {/* DOCUMENTS TAB SECTION */}
{/* DOCUMENTS TAB SECTION */}
{value === DOCUMENTS_INDEX && DOCUMENTS_INDEX !== -1 && (
  <Box sx={{ p: 2 }}>
    <Typography variant="h6" align="center" sx={{ color: 'text.primary', mb: 2 }}>
      Documents
    </Typography>

    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 2 }}>
      {/* Left Column: Folders & Upload Area */}
      <Box
        sx={{
          width: { xs: '100%', md: '35%' },
          overflowY: 'auto',
          border: '1px solid #ccc',
          borderRadius: '4px',
          padding: 2,
          maxHeight: '75vh',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
            Folders {selectedFolder ? `(${selectedFolder})` : '(Root)'}
          </Typography>
          <Stack direction="row" spacing={1}>
            <Stack alignItems="center">
              <IconButton 
                size="small" 
                color="primary" 
                onClick={() => handleOpenNewFolderDialog(false)} 
                disabled={user?.role === 'guest'}
              >
                <CreateNewFolderIcon fontSize="small" />
              </IconButton>
              <Typography variant="caption" sx={{ fontSize: '0.65rem' }}>Root Folder</Typography>
            </Stack>
            <Stack alignItems="center">
              <IconButton 
                size="small" 
                color="secondary" 
                onClick={() => handleOpenNewFolderDialog(true)} 
                disabled={user?.role === 'guest' || folderList.length === 0}
              >
                <CreateNewFolderIcon fontSize="small" />
              </IconButton>
              <Typography variant="caption" sx={{ fontSize: '0.65rem' }}>Subfolder</Typography>
            </Stack>
          </Stack>
        </Box>

        {/* Folder & File Tree */}
        <List dense>
          {(() => {
            const buildTree = (paths) => {
              const root = { children: [] };
              paths.sort().forEach(path => {
                let currentLevel = root;
                path.split('/').forEach(part => {
                  let node = currentLevel.children.find(c => c.name === part);
                  if (!node) {
                    const parentPath = currentLevel.path || '';
                    const currentPath = parentPath ? `${parentPath}/${part}` : part;
                    node = { name: part, path: currentPath, children: [] };
                    currentLevel.children.push(node);
                  }
                  currentLevel = node;
                });
              });
              return root.children;
            };

            const FolderTreeItem = ({ node, level }) => {
              const [isDragOver, setIsDragOver] = React.useState(false);

              const filesInFolder = documents.filter(file => file.folder === node.path && (showTrash ? file.folder === 'Trash' : file.folder !== 'Trash'));
              const hasSubfolders = node.children.length > 0;
              const isOpen = openFolders[node.path];
              const isSelected = selectedFolder === node.path;

              // Only trigger drag behavior during an active drag-and-drop operation
              const handleFolderDragOver = (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (e.dataTransfer.types.includes('Files')) {
                  if (!isDragOver) setIsDragOver(true);
                }
              };

              const handleFolderDragLeave = (e) => {
                e.preventDefault();
                e.stopPropagation();
                setIsDragOver(false);
              };

              const handleFolderDrop = (e) => {
                e.preventDefault();
                e.stopPropagation();
                setIsDragOver(false);

                if (user?.role === 'guest') return;

                const droppedFiles = Array.from(e.dataTransfer?.files || []);
                if (droppedFiles.length > 0) {
                  // Direct upload when files are physically dropped
                  handleFileUpload(node.path, false, droppedFiles);
                }
              };

              return (
                <React.Fragment key={node.path}>
                  <ListItem
                    button
                    onClick={(e) => {
                      e.stopPropagation();
                      // Pure navigation: toggle folder view and select it
                      toggleFolder(node.path);
                    }}
                    onDragOver={handleFolderDragOver}
                    onDragLeave={handleFolderDragLeave}
                    onDrop={handleFolderDrop}
                    sx={{
                      pl: 2 + (level * 2),
                      backgroundColor: isDragOver 
                        ? '#bbdefb' 
                        : isSelected ? '#d0e0ff' : 'transparent',
                      borderRadius: 1,
                      mb: 0.5,
                      border: isDragOver 
                        ? '2px solid #1976d2' 
                        : isSelected ? '1px dashed #1976d2' : '1px solid transparent',
                      transition: 'all 0.15s ease-in-out',
                      '&:hover': { 
                        backgroundColor: isDragOver ? '#bbdefb' : isSelected ? '#c0d8ff' : '#f0f4f8' 
                      }
                    }}
                  >
                    <Typography sx={{ flexGrow: 1, fontWeight: 'bold', fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: 0.75 }}>
                      {isOpen ? '📂' : '📁'} {node.name}
                      <Chip
                        label={filesInFolder.length}
                        size="small"
                        sx={{ height: 18, fontSize: '0.7rem', fontWeight: 'bold', '& .MuiChip-label': { px: 0.75 } }}
                      />
                    </Typography>

                    <Tooltip title="Rename Folder">
                      <IconButton size="small" onClick={(e) => handleOpenRenameFolderDialog(node.path, e)} disabled={user?.role === 'guest'}>
                        <EditIcon fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete Folder">
                      <IconButton size="small" color="error" onClick={(e) => handleDeleteFolder(node.path, e)} disabled={user?.role === 'guest'}>
                        <DeleteIcon fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                    {hasSubfolders && (isOpen ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />)}
                  </ListItem>

                  <Collapse in={isOpen} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {filesInFolder.map(file => (
                        <ListItem key={file.filename || file._id} sx={{ pl: 4 + (level * 2), display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
                          <Box sx={{ flexGrow: 1, overflow: 'hidden', mr: 1, cursor: 'pointer' }} onClick={() => handleOpenPreview(file)}>
                            <Tooltip title={file.filename}>
                              <Typography noWrap variant="body2" sx={{ fontWeight: selectedDocument?.filename === file.filename ? 'bold' : 'normal' }}>
                                📄 {file.filename}
                              </Typography>
                            </Tooltip>
                            <Typography variant="caption" color="text.secondary">
                              {file.createdAt ? new Date(file.createdAt).toLocaleDateString() : ''}
                            </Typography>
                          </Box>
                          <Tooltip title="Rename Document">
                            <IconButton edge="end" size="small" onClick={(e) => handleOpenRenameFileDialog(file, e)} disabled={user?.role === 'guest'}>
                              <EditIcon fontSize="inherit" />
                            </IconButton>
                          </Tooltip>
                          <IconButton edge="end" size="small" color="error" onClick={() => handleDeleteClick(file.filename)} disabled={user?.role === 'guest'}>
                            <DeleteIcon fontSize="inherit" />
                          </IconButton>
                        </ListItem>
                      ))}
                      {node.children.map(childNode => (
                        <FolderTreeItem key={childNode.path} node={childNode} level={level + 1} />
                      ))}
                    </List>
                  </Collapse>
                </React.Fragment>
              );
            };

            // 7.7: Enquiry confidentiality - hide the "Enquiries & Litigation" folder (and any
            // subfolders under it) from guest (outside) users entirely.
            const visibleFolderList = user?.role === 'guest'
              ? folderList.filter(f => f !== 'Enquiries & Litigation' && !f.startsWith('Enquiries & Litigation/'))
              : folderList;
            const folderTree = buildTree(visibleFolderList);
            return folderTree.map(node => <FolderTreeItem key={node.path} node={node} level={0} />);
          })()}

          {/* Root Unfolderable Files */}
          {(Array.isArray(documents) ? documents : [])
            .filter((file) => !file.folder && !showTrash)
            .map((file) => (
              <ListItem
                key={file.filename || file._id}
                sx={{
                  marginBottom: 1,
                  cursor: 'pointer',
                  display: 'flex',
                  justify: 'space-between',
                  alignItems: 'center',
                  '&:hover': { backgroundColor: '#f5f5f5' },
                  paddingLeft: 2,
                  borderRadius: 1
                }}
              >
                <Box sx={{ flexGrow: 1, overflow: 'hidden', mr: 1 }} onClick={() => handleOpenPreview(file)}>
                  <Tooltip title={file.filename} arrow>
                    <Typography variant="body2" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: 500 }}>
                      📄 {file.filename}
                    </Typography>
                  </Tooltip>
                  <Typography variant="caption" color="text.secondary" display="block">
                    Uploaded: {file.createdAt ? new Date(file.createdAt).toLocaleString('en-ZA', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : 'N/A'}
                    {(file.uploadedBy || file.uploaderName || file.user?.firstName) ? ` • By: ${file.uploadedBy || file.uploaderName || file.user?.firstName}` : ''}
                  </Typography>
                </Box>
                <Tooltip title="Rename Document">
                  <IconButton edge="end" size="small" onClick={(e) => handleOpenRenameFileDialog(file, e)} disabled={user?.role === 'guest'}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <IconButton edge="end" size="small" onClick={() => handleDeleteClick(file.filename)} sx={{ color: 'red' }} disabled={user?.role === 'guest'}>
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </ListItem>
            ))}
        </List>

        {/* General / Root Upload Drop Zone */}
        <Box
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={(e) => {
            e.preventDefault();
            setIsDragging(false);
            const droppedFiles = Array.from(e.dataTransfer?.files || []);
            if (droppedFiles.length > 0) {
              handleFileUpload(null, false, droppedFiles);
            }
          }}
          onClick={() => hiddenFileInput.current && hiddenFileInput.current.click()}
          sx={{
            border: `2px dashed ${isDragging ? theme.palette.primary.main : theme.palette.divider}`,
            borderRadius: 1, p: 2, mt: 2, textAlign: 'center', cursor: 'pointer',
            backgroundColor: isDragging ? theme.palette.action.hover : '#fafafa',
            transition: 'background-color 0.2s, border-color 0.2s',
          }}
        >
          <input
            type="file"
            accept=".pdf,.docx,.jpg,.jpeg,.png,.txt,.xlsx,.pptx,.mp3,.wav,.m4a,.zip"
            onChange={(e) => {
              const files = Array.from(e.target.files || []);
              if (files.length > 0) {
                handleFileUpload(null, false, files);
              }
              e.target.value = null;
            }}
            multiple
            style={{ display: 'none' }}
            ref={hiddenFileInput}
          />
          <Typography variant="body2" color="text.secondary">
            Click or drop files here to upload to <strong>Root</strong> (or drop directly onto any folder above)
          </Typography>
        </Box>

        {/* Upload Progress */}
        {uploading && (
          <Box sx={{ width: '100%', mt: 1 }}>
            <LinearProgress variant="determinate" value={uploadProgress} />
            <Typography variant="caption" sx={{ mt: 0.5, display: 'block', textAlign: 'right' }}>
              Uploading: {uploadProgress}%
            </Typography>
          </Box>
        )}
      </Box>

{/* Right Column - Document Previewer */}
<Box
  sx={{
    width: { xs: '100%', md: '65%' },
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
    p: 2,
    minHeight: '500px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
  }}
>
  {selectedDocument ? (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
      {/* Header bar */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }} noWrap>
          📄 {selectedDocument.filename}
        </Typography>
        <Button
          size="small"
          variant="outlined"
          color="primary"
          onClick={() => {
            const raw = selectedDocument.filepath || selectedDocument.path || '';
            const clean = getUploadsRelativePath(raw);
            const targetUrl = clean.startsWith('http') ? clean : `https://demo.insollex.com/${clean}`;
            window.open(encodeURI(targetUrl), '_blank');
          }}
        >
          Open in New Tab
        </Button>
      </Box>

      {/* Dynamic Viewer Frame */}
      <Box sx={{ flexGrow: 1, minHeight: '500px', width: '100%', border: '1px solid #ddd', borderRadius: 1, overflow: 'hidden' }}>
        {(() => {
          const raw = selectedDocument.filepath || selectedDocument.path || '';
          const clean = getUploadsRelativePath(raw);
          const rawUrl = clean.startsWith('http') ? clean : `https://demo.insollex.com/${clean}`;
          const finalUrl = encodeURI(rawUrl);

          const ext = selectedDocument.filename?.split('.').pop()?.toLowerCase() || '';

          // A. PDFs
          if (ext === 'pdf') {
            return (
              <iframe
                key={finalUrl}
                src={`${finalUrl}#toolbar=0`}
                title={selectedDocument.filename}
                width="100%"
                height="100%"
                style={{ border: 'none', minHeight: '500px' }}
              />
            );
          }

          // B. Images (JPG, PNG, GIF, WEBP)
          if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) {
            return (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', p: 2, bgcolor: '#f9f9f9' }}>
                <img
                  key={finalUrl}
                  src={finalUrl}
                  alt={selectedDocument.filename}
                  style={{ maxWidth: '100%', maxHeight: '500px', objectFit: 'contain' }}
                />
              </Box>
            );
          }

          // C. Word, Excel, PowerPoint (Use Microsoft Office Embed Viewer)
          if (['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(ext)) {
            const officeViewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(finalUrl)}`;
            return (
              <iframe
                key={finalUrl}
                src={officeViewerUrl}
                title={selectedDocument.filename}
                width="100%"
                height="100%"
                style={{ border: 'none', minHeight: '500px' }}
              />
            );
          }

          // D. Fallback component for standard DocumentPreviewer
          return (
            <DocumentPreviewer
              key={finalUrl}
              filepath={finalUrl}
              filename={selectedDocument.filename}
            />
          );
        })()}
      </Box>
    </Box>
  ) : (
    <Box
      sx={{
        display: 'flex',
        height: '100%',
        minHeight: '500px',
        alignItems: 'center',
        justify: 'center',
      }}
    >
      <Typography variant="h6" color="text.secondary">
        Select a document to preview
      </Typography>
    </Box>
  )}
</Box>
</Box>

    {/* Dialogs */}
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>Confirm Deletion</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete <strong>{selectedFile}</strong>? This action will move the file to the Trash.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} color="primary">Cancel</Button>
        <Button onClick={handleConfirmDelete} color="error" disabled={user?.role === 'guest' || user?.isInvited}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>

    <Dialog open={newFolderDialogOpen} onClose={handleCloseNewFolderDialog} fullWidth maxWidth="sm">
      <DialogTitle>{isSubfolderDialog ? 'Create New Subfolder' : 'Create New Root Folder'}</DialogTitle>
      <DialogContent>
        {isSubfolderDialog && (
          <FormControl fullWidth margin="dense" sx={{ mt: 1, mb: 2 }}>
            <InputLabel>Parent Folder</InputLabel>
            <Select
              value={parentForNewFolder}
              onChange={(e) => setParentForNewFolder(e.target.value)}
              label="Parent Folder"
            >
              {folderList.map(folder => (
                <MenuItem key={folder} value={folder}>{folder}</MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <TextField autoFocus={!isSubfolderDialog} margin="dense" label={isSubfolderDialog ? "Subfolder Name" : "Folder Name"} type="text" fullWidth variant="outlined" value={newFolderName} onChange={(e) => setNewFolderName(e.target.value)} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseNewFolderDialog}>Cancel</Button>
        <Button onClick={handleCreateFolder} variant="contained" color="primary">Create</Button>
      </DialogActions>
    </Dialog>

    <Dialog open={renameFolderDialogOpen} onClose={handleCloseRenameFolderDialog}>
      <DialogTitle>Rename Folder</DialogTitle>
      <DialogContent>
        <TextField autoFocus margin="dense" label="New Folder Name" type="text" fullWidth variant="outlined" value={renameFolderName} onChange={(e) => setRenameFolderName(e.target.value)} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseRenameFolderDialog}>Cancel</Button>
        <Button onClick={handleRenameFolderSubmit} variant="contained" color="primary">Rename</Button>
      </DialogActions>
    </Dialog>

    {/* 🎯 10.1: Rename Document Dialog - only the displayed name changes, the file itself is untouched */}
    <Dialog open={renameFileDialogOpen} onClose={handleCloseRenameFileDialog} fullWidth maxWidth="sm">
      <DialogTitle>Rename Document</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Document Name"
          type="text"
          fullWidth
          variant="outlined"
          value={renameFileName}
          onChange={(e) => setRenameFileName(e.target.value)}
          helperText="Only the displayed name changes - the uploaded file itself is not affected."
          onKeyDown={(e) => { if (e.key === 'Enter' && !renameFileSaving) handleRenameFileSubmit(); }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseRenameFileDialog} disabled={renameFileSaving}>Cancel</Button>
        <Button onClick={handleRenameFileSubmit} variant="contained" color="primary" disabled={renameFileSaving}>
          {renameFileSaving ? 'Saving...' : 'Rename'}
        </Button>
      </DialogActions>
    </Dialog>
  </Box>
)}

          {/* Fixed Save/Update Button visible only on Estate Information Tab */}
          {value === 0 && isEditingMode && (
            <Box sx={{ position: 'fixed', bottom: 16, right: 16, zIndex: 1300, display: 'flex', alignItems: 'center', gap: 1.5 }}>
              {!isLoading && autoSaveStatus === 'saving' && (
                <Typography variant="caption" sx={{ color: 'text.secondary', bgcolor: 'background.paper', px: 1, py: 0.5, borderRadius: 1, boxShadow: 1 }}>
                  Saving...
                </Typography>
              )}
              {!isLoading && autoSaveStatus === 'saved' && (
                <Typography variant="caption" sx={{ color: 'success.main', bgcolor: 'background.paper', px: 1, py: 0.5, borderRadius: 1, boxShadow: 1 }}>
                  ✓ Autosaved
                </Typography>
              )}
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleSaveData()}
                sx={{ fontSize: '1rem', p: '10px 20px', boxShadow: 2, borderRadius: 2 }}
                disabled={isLoading || (!formData?.estateNo && !isNPAClassification) || user?.role === 'guest'}
              >
                {isLoading ? 'Saving...' : formData?.id ? 'Update Estate' : 'Save Estate'}
              </Button>
            </Box>
          )}

        </React.Fragment>
      )}
    </Box>
  );
};

export default MatterDetailPage;